var _g, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _g2, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _g3, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _g4, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgComputer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 181,
    height: 200,
    viewBox: "0 0 181 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1148_2557)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_1148_2557)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 118.922,
    cy: 160.264,
    rx: 55.7211,
    ry: 27.6836,
    fill: "#181F26",
    fillOpacity: 0.15
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M158.156 146.041L159.548 142.994L167.564 141.755L172.558 144.638L171.172 147.684L163.155 148.929L158.156 146.041Z",
    fill: "url(#paint0_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M153.49 136.077L154.882 133.031L162.898 131.786L167.903 134.674L166.511 137.715L158.495 138.96L153.49 136.077Z",
    fill: "url(#paint1_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M145.604 153.334L146.991 150.293L155.013 149.049L160.012 151.937L158.62 154.977L150.609 156.222L145.604 153.334Z",
    fill: "url(#paint2_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M140.944 143.371L142.335 140.33L150.347 139.08L155.351 141.973L153.965 145.014L145.943 146.259L140.944 143.371Z",
    fill: "url(#paint3_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M133.058 160.633L134.45 157.587L142.455 156.342L147.46 159.23L146.074 162.276L138.057 163.521L133.058 160.633Z",
    fill: "url(#paint4_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M131.612 123.439L133.004 120.393L141.015 119.148L146.019 122.042L144.633 125.077L136.611 126.327L131.612 123.439Z",
    fill: "url(#paint5_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M128.392 150.665L129.784 147.624L137.79 146.374L142.794 149.267L141.408 152.308L133.391 153.553L128.392 150.665Z",
    fill: "url(#paint6_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M136.278 133.402L137.664 130.356L145.681 129.111L150.68 132.005L149.288 135.046L141.282 136.296L136.278 133.402Z",
    fill: "url(#paint7_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M123.721 140.696L125.107 137.655L133.129 136.411L138.128 139.298L136.736 142.339L128.725 143.589L123.721 140.696Z",
    fill: "url(#paint8_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M120.507 167.932L121.898 164.88L129.915 163.641L134.914 166.529L133.522 169.57L125.505 170.815L120.507 167.932Z",
    fill: "url(#paint9_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.11,
    d: "M119.061 130.733L120.452 127.687L128.463 126.442L133.473 129.335L132.082 132.376L124.059 133.621L119.061 130.733Z",
    fill: "url(#paint10_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.32,
    d: "M115.846 157.964L117.232 154.923L125.249 153.673L130.253 156.566L128.867 159.607L120.845 160.852L115.846 157.964Z",
    fill: "url(#paint11_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M109.729 110.801L111.12 107.755L119.137 106.51L124.141 109.404L122.749 112.439L114.733 113.689L109.729 110.801Z",
    fill: "url(#paint12_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M107.96 175.226L109.352 172.18L117.363 170.935L122.362 173.823L120.97 176.869L112.959 178.114L107.96 175.226Z",
    fill: "url(#paint13_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M103.294 165.257L104.686 162.216L112.697 160.972L117.702 163.86L116.315 166.9L108.293 168.145L103.294 165.257Z",
    fill: "url(#paint14_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.32,
    d: "M114.395 120.764L115.786 117.718L123.797 116.479L128.796 119.367L127.41 122.408L119.399 123.658L114.395 120.764Z",
    fill: "url(#paint15_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M106.514 138.032L107.9 134.986L115.917 133.741L120.916 136.629L119.524 139.67L111.513 140.914L106.514 138.032Z",
    fill: "url(#paint16_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M111.175 147.995L112.566 144.943L120.572 143.704L125.576 146.592L124.19 149.638L116.19 150.888L111.175 147.995Z",
    fill: "url(#paint17_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M97.1824 118.095L98.574 115.054L106.585 113.804L111.589 116.697L110.203 119.738L102.181 120.983L97.1824 118.095Z",
    fill: "url(#paint18_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M93.9626 145.325L95.3542 142.279L103.365 141.034L108.37 143.928L106.984 146.963L98.9615 148.213L93.9626 145.325Z",
    fill: "url(#paint19_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.32,
    d: "M90.7429 172.556L92.1345 169.51L100.146 168.265L105.155 171.159L103.764 174.194L95.7417 175.444L90.7429 172.556Z",
    fill: "url(#paint20_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.32,
    d: "M87.8506 98.1629L89.2367 95.1167L97.2534 93.8719L102.258 96.7654L100.866 99.8007L92.8494 101.051L87.8506 98.1629Z",
    fill: "url(#paint21_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M98.623 155.289L100.02 152.242L108.031 151.003L113.03 153.891L111.639 156.932L103.638 158.182L98.623 155.289Z",
    fill: "url(#paint22_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.32,
    d: "M84.6306 125.394L86.0222 122.347L94.028 121.097L99.0322 123.991L97.6461 127.032L89.6294 128.276L84.6306 125.394Z",
    fill: "url(#paint23_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M82.8572 189.818L84.2488 186.767L92.26 185.522L97.2643 188.415L95.8727 191.456L87.8615 192.706L82.8572 189.818Z",
    fill: "url(#paint24_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.32,
    d: "M81.4109 152.619L82.8025 149.578L90.8137 148.333L95.8234 151.221L94.4318 154.262L86.4097 155.507L81.4109 152.619Z",
    fill: "url(#paint25_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.32,
    d: "M92.5164 108.126L93.908 105.08L101.914 103.841L106.918 106.729L105.526 109.769L97.5206 111.02L92.5164 108.126Z",
    fill: "url(#paint26_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.11,
    d: "M79.9595 115.42L81.3511 112.379L89.3677 111.134L94.3666 114.022L92.975 117.068L84.9638 118.313L79.9595 115.42Z",
    fill: "url(#paint27_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.32,
    d: "M95.4033 182.519L96.7949 179.473L104.812 178.234L109.81 181.116L108.424 184.163L100.408 185.407L95.4033 182.519Z",
    fill: "url(#paint28_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M78.1968 179.85L79.5884 176.804L87.5887 175.559L92.5984 178.452L91.2068 181.493L83.1956 182.738L78.1968 179.85Z",
    fill: "url(#paint29_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M89.2966 135.357L90.6882 132.311L98.694 131.066L103.698 133.959L102.312 137L94.3064 138.25L89.2966 135.357Z",
    fill: "url(#paint30_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.11,
    d: "M75.2988 105.457L76.6904 102.41L84.7016 101.171L89.7059 104.059L88.3198 107.1L80.2977 108.344L75.2988 105.457Z",
    fill: "url(#paint31_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.11,
    d: "M86.0769 162.588L87.4685 159.541L95.4797 158.297L100.479 161.185L99.087 164.231L91.0812 165.481L86.0769 162.588Z",
    fill: "url(#paint32_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.11,
    d: "M73.5198 169.881L74.9114 166.835L82.9335 165.59L87.9323 168.484L86.5407 171.524L78.5241 172.769L73.5198 169.881Z",
    fill: "url(#paint33_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M72.0845 132.687L73.4706 129.647L81.4873 128.396L86.4916 131.29L85.1 134.331L77.0778 135.575L72.0845 132.687Z",
    fill: "url(#paint34_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M70.3054 197.106L71.6916 194.066L79.7137 192.826L84.7125 195.709L83.3209 198.755L75.3097 200L70.3054 197.106Z",
    fill: "url(#paint35_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M68.8647 159.918L70.2509 156.872L78.2621 155.627L83.2718 158.52L81.8802 161.556L73.8636 162.806L68.8647 159.918Z",
    fill: "url(#paint36_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.32,
    d: "M65.645 187.149L67.0366 184.103L75.0478 182.858L80.0521 185.746L78.666 188.787L70.6438 190.031L65.645 187.149Z",
    fill: "url(#paint37_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M76.7451 142.656L78.1422 139.604L86.1479 138.365L91.1522 141.253L89.7606 144.299L81.7549 145.544L76.7451 142.656Z",
    fill: "url(#paint38_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M62.7473 112.756L64.1389 109.709L72.1556 108.465L77.1544 111.353L75.7628 114.393L67.7461 115.638L62.7473 112.756Z",
    fill: "url(#paint39_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.32,
    d: "M59.533 139.981L60.9246 136.94L68.9358 135.695L73.9401 138.583L72.5539 141.624L64.5318 142.869L59.533 139.981Z",
    fill: "url(#paint40_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.11,
    d: "M56.3132 167.212L57.7048 164.165L65.716 162.926L70.7149 165.809L69.3233 168.855L61.3121 170.1L56.3132 167.212Z",
    fill: "url(#paint41_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M67.4131 122.719L68.8047 119.672L76.8104 118.428L81.8202 121.316L80.4286 124.362L72.4228 125.612L67.4131 122.719Z",
    fill: "url(#paint42_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M64.199 149.949L65.5906 146.903L73.6018 145.658L78.6006 148.546L77.209 151.593L69.2033 152.843L64.199 149.949Z",
    fill: "url(#paint43_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.32,
    d: "M51.6418 157.243L53.0334 154.197L61.0501 152.958L66.0489 155.84L64.6628 158.886L56.6461 160.131L51.6418 157.243Z",
    fill: "url(#paint44_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.32,
    d: "M50.2012 120.049L51.5873 117.003L59.604 115.758L64.6083 118.651L63.2167 121.692L55.2 122.937L50.2012 120.049Z",
    fill: "url(#paint45_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M60.9736 177.18L62.3707 174.128L70.3764 172.884L75.3807 175.777L73.9891 178.823L65.9834 180.074L60.9736 177.18Z",
    fill: "url(#paint46_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M48.4221 184.468L49.8137 181.428L57.8304 180.183L62.8292 183.071L61.4431 186.117L53.4264 187.362L48.4221 184.468Z",
    fill: "url(#paint47_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M46.9812 147.28L48.3728 144.234L56.384 142.989L61.3883 145.882L60.0022 148.918L51.98 150.168L46.9812 147.28Z",
    fill: "url(#paint48_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M43.7615 174.505L45.1531 171.464L53.1643 170.22L58.174 173.108L56.7824 176.148L48.7658 177.393L43.7615 174.505Z",
    fill: "url(#paint49_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.11,
    d: "M34.4351 154.573L35.8212 151.527L43.827 150.282L48.8367 153.17L47.4451 156.217L39.4339 157.461L34.4351 154.573Z",
    fill: "url(#paint50_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.11,
    d: "M37.6494 127.343L39.041 124.302L47.0522 123.057L52.0565 125.945L50.6704 128.986L42.6482 130.231L37.6494 127.343Z",
    fill: "url(#paint51_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M42.3154 137.311L43.707 134.265L51.7182 133.02L56.7171 135.908L55.3255 138.954L47.3252 140.205L42.3154 137.311Z",
    fill: "url(#paint52_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M29.7583 144.605L31.1499 141.559L39.1666 140.314L44.1709 143.207L42.7793 146.248L34.7626 147.493L29.7583 144.605Z",
    fill: "url(#paint53_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M39.0957 164.542L40.4873 161.496L48.4931 160.251L53.5028 163.139L52.1112 166.185L44.1 167.43L39.0957 164.542Z",
    fill: "url(#paint54_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M26.5439 171.83L27.9355 168.789L35.9522 167.55L40.951 170.433L39.5594 173.479L31.5482 174.724L26.5439 171.83Z",
    fill: "url(#paint55_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M25.1033 134.642L26.4894 131.595L34.5061 130.351L39.5104 133.244L38.1188 136.279L30.1021 137.53L25.1033 134.642Z",
    fill: "url(#paint56_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M21.8835 161.873L23.2751 158.826L31.2864 157.582L36.2906 160.469L34.9045 163.51L26.8824 164.76L21.8835 161.873Z",
    fill: "url(#paint57_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M12.5515 141.935L13.9431 138.894L21.9543 137.65L26.9531 140.538L25.5616 143.579L17.5503 144.823L12.5515 141.935Z",
    fill: "url(#paint58_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M17.2175 151.904L18.6091 148.858L26.6149 147.613L31.6192 150.501L30.2276 153.547L22.2218 154.797L17.2175 151.904Z",
    fill: "url(#paint59_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M4.6604 159.197L6.05199 156.151L14.0687 154.906L19.0675 157.794L17.6759 160.841L9.66468 162.085L4.6604 159.197Z",
    fill: "url(#paint60_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31,
    d: "M0 149.234L1.39159 146.188L9.40281 144.943L14.4125 147.837L13.021 150.872L4.99882 152.122L0 149.234Z",
    fill: "url(#paint61_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M101.837 128.058L103.229 125.017L111.246 123.772L116.25 126.66L114.858 129.707L106.847 130.951L101.837 128.058Z",
    fill: "url(#paint62_radial_1148_2557)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.31
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.75,
    d: "M54.8669 130.018L56.2585 126.966L64.2698 125.727L69.2686 128.615L67.877 131.661L59.8767 132.911L54.8669 130.018Z",
    fill: "url(#paint63_radial_1148_2557)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M143.967 149.338C143.223 150.25 142.33 151.028 141.326 151.642L124.021 161.845C123.803 161.976 123.557 162.102 123.323 162.222C123.088 162.342 122.82 162.462 122.564 162.571C122.307 162.68 122.018 162.784 121.756 162.882C121.494 162.981 121.211 163.068 120.916 163.15C120.485 163.276 120.032 163.39 119.579 163.483C119.126 163.576 118.657 163.647 118.193 163.707C117.729 163.767 117.243 163.811 116.768 163.832C115.691 163.886 114.611 163.855 113.538 163.74C113.068 163.685 112.61 163.614 112.152 163.532C111.693 163.45 111.262 163.341 110.825 163.226C110.389 163.112 109.98 162.975 109.57 162.828C109.297 162.73 109.025 162.626 108.784 162.511C108.61 162.44 108.446 162.364 108.282 162.287C107.999 162.145 107.737 161.998 107.458 161.845L85.8041 149.109C85.5803 148.978 85.3621 148.836 85.1601 148.699C84.9582 148.563 84.7508 148.404 84.5653 148.252C84.3798 148.099 84.1997 147.94 84.0196 147.777C83.8583 147.619 83.7053 147.453 83.5612 147.28C83.3595 147.034 83.1771 146.773 83.0154 146.499C82.86 146.24 82.7302 145.965 82.628 145.68C82.5284 145.41 82.4571 145.13 82.4151 144.845C82.3843 144.645 82.3697 144.442 82.3715 144.239C82.3705 143.799 82.4406 143.363 82.5789 142.945C82.6719 142.664 82.7907 142.392 82.9336 142.132C83.0846 141.858 83.2581 141.597 83.452 141.351C83.658 141.09 83.8823 140.844 84.1233 140.614C84.2979 140.45 84.4725 140.303 84.669 140.15C84.8654 139.997 84.9255 139.954 85.0619 139.855C85.2966 139.686 85.5476 139.528 85.8095 139.369L103.114 129.193C104.12 128.582 105.013 127.803 105.756 126.89L143.967 149.338Z",
    fill: "url(#paint64_linear_1148_2557)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M174.85 70.6755L63.6368 5.27903C63.0631 4.89268 62.407 4.64601 61.7209 4.5588C61.0348 4.47159 60.3379 4.54623 59.6858 4.77675L54.6433 6.84037C55.7784 6.37087 57.17 6.50188 58.5944 7.34261L169.785 72.7227C172.951 74.5843 175.123 79.2247 174.637 83.0953L166.162 150.244L171.21 148.181L179.679 81.0317C180.187 77.1611 178.015 72.5207 174.85 70.6755Z",
    fill: "url(#paint65_linear_1148_2557)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M168.023 156.632L163.051 158.668C164.394 158.084 165.376 156.648 165.638 154.563C165.824 153.125 166.005 151.686 166.184 150.244L171.232 148.181C171.046 149.622 170.866 151.058 170.686 152.499C170.419 154.617 169.403 156.069 168.023 156.632Z",
    fill: "url(#paint66_linear_1148_2557)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.967 149.338C143.223 150.249 142.33 151.028 141.326 151.642L124.021 161.845C123.803 161.976 123.557 162.102 123.323 162.222C123.088 162.342 122.82 162.462 122.564 162.571C122.308 162.68 122.018 162.784 121.756 162.882C121.494 162.981 121.211 163.068 120.916 163.15C120.485 163.275 120.032 163.39 119.579 163.483C119.126 163.576 118.657 163.647 118.193 163.707C117.729 163.767 117.243 163.81 116.768 163.832C115.691 163.886 114.611 163.855 113.538 163.739C113.068 163.685 112.61 163.614 112.152 163.532C111.693 163.45 111.262 163.341 110.825 163.226C110.389 163.112 109.98 162.975 109.57 162.828C109.297 162.73 109.025 162.626 108.784 162.511C108.61 162.44 108.446 162.364 108.282 162.287C107.999 162.145 107.737 161.998 107.458 161.845L85.8041 149.109C85.5803 148.978 85.3621 148.836 85.1601 148.699C84.9582 148.563 84.7508 148.404 84.5653 148.252C84.3798 148.099 84.1997 147.94 84.0196 147.777C83.8583 147.619 83.7053 147.453 83.5612 147.28C83.3595 147.034 83.1771 146.773 83.0154 146.499C82.86 146.239 82.7302 145.965 82.628 145.68C82.5284 145.41 82.4571 145.13 82.4151 144.845C82.3843 144.644 82.3697 144.442 82.3715 144.239V148.508C82.3745 149.029 82.4725 149.545 82.6607 150.031C82.9125 150.675 83.2828 151.266 83.7522 151.773C84.3454 152.406 85.0296 152.947 85.7822 153.378L107.437 166.109C109.544 167.276 111.89 167.948 114.296 168.074C116.206 168.217 118.126 168.075 119.994 167.654C121.399 167.343 122.749 166.822 123.999 166.109L141.304 155.933C143.393 154.64 145.197 152.937 146.609 150.927L143.967 149.338Z",
    fill: "url(#paint67_linear_1148_2557)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.184 150.244C166.005 151.7 165.823 153.139 165.638 154.562C165.376 156.648 164.394 158.084 163.051 158.668L162.975 158.701C161.84 159.165 160.453 159.034 159.024 158.193L146.63 150.927L143.967 149.36L105.767 126.889L47.8544 92.84C44.6892 90.9784 42.5173 86.3326 43.003 82.4674C43.1885 81.0262 43.3686 79.5904 43.5487 78.1492L166.184 150.244Z",
    fill: "url(#paint68_linear_1148_2557)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M43.5322 78.1273C46.3518 55.7444 49.175 33.3614 52.0018 10.9784C52.2692 8.85477 53.2843 7.40807 54.665 6.84576C55.8001 6.37627 57.1917 6.50728 58.616 7.348L169.807 72.7281C172.972 74.5897 175.144 79.2301 174.659 83.1007L166.184 150.25L43.5322 78.1273Z",
    fill: "url(#paint69_linear_1148_2557)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M141.326 151.647L134.63 155.654L127.912 159.623L124.556 161.61C124.277 161.78 124.01 161.943 123.704 162.096C123.399 162.249 123.121 162.397 122.826 162.533L122.602 162.637L122.373 162.724L121.914 162.904C121.609 163.019 121.292 163.106 120.981 163.21C120.67 163.314 120.348 163.374 120.032 163.45L119.557 163.565L119.071 163.647C118.749 163.696 118.427 163.761 118.105 163.8L117.128 163.892C116.477 163.95 115.823 163.966 115.169 163.942C114.514 163.929 113.86 163.878 113.21 163.789L112.239 163.641C111.917 163.581 111.6 163.494 111.284 163.423L110.804 163.314L110.34 163.166C110.029 163.063 109.712 162.975 109.406 162.855C109.101 162.735 108.795 162.62 108.501 162.478C108.206 162.337 107.917 162.178 107.622 162.031C107.076 161.714 106.498 161.37 105.936 161.043L99.2178 157.068L92.5054 153.11L85.804 149.103L92.56 153.012L99.2997 156.948L106.039 160.89C107.13 161.588 108.283 162.184 109.483 162.67C109.783 162.784 110.094 162.866 110.4 162.97L110.864 163.112L111.338 163.221C111.655 163.286 111.966 163.374 112.282 163.428L113.243 163.565C113.883 163.66 114.528 163.716 115.175 163.734C115.821 163.758 116.468 163.743 117.112 163.69L118.078 163.609C118.4 163.57 118.717 163.51 119.038 163.461L119.513 163.385L119.988 163.27C120.299 163.194 120.616 163.123 120.927 163.041C121.238 162.959 121.549 162.85 121.849 162.735L122.302 162.566L122.526 162.478L122.749 162.38C123.044 162.244 123.339 162.113 123.617 161.954C123.895 161.796 124.163 161.643 124.463 161.474L127.836 159.509L134.57 155.567L141.326 151.647Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M58.6162 7.34814L81.1327 20.5159L103.627 33.7218L148.617 60.1283L159.859 66.7503L165.474 70.0587L168.285 71.6964L169.687 72.5263C169.927 72.6573 170.151 72.8211 170.38 72.9685C170.609 73.1159 170.817 73.3069 171.03 73.4762C171.848 74.2102 172.547 75.0666 173.103 76.0147C173.664 76.9581 174.097 77.9713 174.391 79.0282C174.693 80.0838 174.832 81.179 174.806 82.2765C174.806 82.5549 174.768 82.8224 174.746 83.1008L174.642 83.9088L174.435 85.5466L172.798 98.4905L169.524 124.373L166.2 150.25L169.409 124.356L172.683 98.4686L174.32 85.5247L174.522 83.887L174.626 83.079C174.626 82.806 174.675 82.5331 174.686 82.271C174.709 81.1917 174.569 80.115 174.271 79.0774C173.98 78.0376 173.552 77.0408 173 76.113C172.453 75.1839 171.764 74.3458 170.959 73.629C170.751 73.4598 170.544 73.2851 170.326 73.1322C170.107 72.9794 169.884 72.832 169.649 72.6955L168.241 71.8711L165.431 70.2334L159.804 66.9305L148.557 60.3303L103.606 33.8528L81.1 20.6196L58.6162 7.34814Z",
    fill: "url(#paint70_linear_1148_2557)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M170.86 132.065C171.406 131.846 171.745 132.119 171.679 132.676C171.626 132.978 171.502 133.262 171.318 133.507C171.134 133.752 170.895 133.95 170.62 134.085C170.102 134.303 169.736 134.03 169.802 133.473C169.855 133.172 169.979 132.887 170.163 132.643C170.347 132.398 170.586 132.2 170.86 132.065Z",
    fill: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M170.446 135.559C170.964 135.341 171.33 135.613 171.264 136.17C171.21 136.471 171.086 136.756 170.902 137C170.718 137.245 170.48 137.443 170.206 137.579C169.687 137.797 169.321 137.524 169.387 136.967C169.44 136.666 169.564 136.381 169.748 136.137C169.932 135.892 170.171 135.694 170.446 135.559Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M169.676 142.001C170.195 141.782 170.56 142.055 170.495 142.612C170.443 142.914 170.319 143.199 170.135 143.444C169.951 143.689 169.712 143.887 169.436 144.021C168.923 144.239 168.552 143.966 168.618 143.409C168.672 143.108 168.796 142.824 168.98 142.579C169.164 142.335 169.402 142.137 169.676 142.001Z",
    fill: "white"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M169.305 145.156C169.627 145.02 169.851 145.189 169.813 145.533C169.78 145.721 169.703 145.899 169.588 146.052C169.474 146.205 169.324 146.328 169.152 146.412C168.83 146.548 168.607 146.379 168.645 146.03C168.679 145.843 168.757 145.666 168.871 145.514C168.986 145.363 169.135 145.24 169.305 145.156Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M179.701 81.0481C180.187 77.1775 178.015 72.5371 174.85 70.6755L63.6369 5.27903C63.0632 4.89268 62.407 4.64601 61.7209 4.5588C61.0349 4.47159 60.3379 4.54623 59.6858 4.77675L54.6433 6.84037C53.2627 7.38629 52.2476 8.84938 51.9802 10.973C49.3171 32.1076 46.6521 53.2404 43.9854 74.3714L43.5106 78.1219C43.3305 79.5632 43.1504 80.9989 42.9649 82.4402C42.4792 86.3054 44.6512 90.9512 47.8164 92.8128L105.728 126.862C104.986 127.775 104.093 128.555 103.087 129.166L85.7823 139.342C85.5204 139.5 85.2693 139.659 85.0347 139.828C84.8982 139.926 84.7673 140.019 84.6417 140.123C84.5162 140.226 84.2816 140.423 84.096 140.587C83.8551 140.816 83.6307 141.062 83.4248 141.324C83.2308 141.569 83.0574 141.83 82.9063 142.104C82.7634 142.364 82.6447 142.636 82.5516 142.918C82.4133 143.335 82.3433 143.772 82.3442 144.212V148.481C82.3473 149.002 82.4453 149.518 82.6335 150.004C82.8853 150.648 83.2555 151.238 83.7249 151.746C84.3182 152.378 85.0024 152.919 85.755 153.351L107.409 166.082C109.517 167.249 111.863 167.921 114.269 168.047C116.177 168.19 118.095 168.048 119.961 167.627C121.368 167.316 122.72 166.795 123.972 166.082L141.277 155.905C143.365 154.613 145.17 152.91 146.581 150.899L158.975 158.187C160.404 159.028 161.791 159.159 162.926 158.695L163.002 158.662L167.974 156.626C169.354 156.08 170.369 154.617 170.637 152.493C170.817 151.052 170.997 149.616 171.183 148.175L166.135 150.239L171.183 148.175L179.701 81.0481ZM82.4861 145.336C82.437 145.166 82.3987 144.993 82.3715 144.818C82.4146 144.996 82.4693 145.171 82.5353 145.342L82.4861 145.336ZM84.5162 148.224C84.4235 148.148 84.3416 148.066 84.2543 147.984C84.3416 148.066 84.4235 148.148 84.5162 148.224L84.8055 148.454L84.5162 148.224ZM85.3566 148.825C85.4876 148.912 85.6186 149.005 85.755 149.081C85.6677 149.01 85.5367 148.918 85.4058 148.83L85.3566 148.825Z",
    fill: "url(#paint71_linear_1148_2557)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M96.4728 29.6111L44.8038 68.0552C44.3854 71.4108 43.9615 74.7719 43.5322 78.1384L61.039 88.4292L123.006 45.2191L96.4728 29.6111Z",
    fill: "url(#paint72_linear_1148_2557)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M132.622 50.8694L70.0928 93.7519L88.1944 104.387L149.763 60.9363L132.622 50.8694Z",
    fill: "url(#paint73_linear_1148_2557)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M67.0749 31.9148C67.3707 32.1082 67.6168 32.3687 67.7931 32.675C67.9695 32.9814 68.0712 33.325 68.0899 33.6781C68.0899 34.3223 67.6315 34.5843 67.0694 34.2568L61.443 30.9812C61.1476 30.7886 60.9018 30.5291 60.7254 30.2237C60.549 29.9183 60.4471 29.5755 60.428 29.2233C60.428 28.5737 60.8864 28.3116 61.4485 28.6392L67.0749 31.9148Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M75.0971 36.5116C75.3942 36.7041 75.6416 36.9642 75.8189 37.2707C75.9963 37.5771 76.0986 37.9213 76.1176 38.2749C76.1176 38.9191 75.6537 39.1811 75.0916 38.859L71.1842 36.5989C70.8879 36.4073 70.6414 36.148 70.4649 35.8424C70.2884 35.5367 70.1871 35.1935 70.1692 34.841C70.1692 34.1914 70.6276 33.9293 71.1897 34.2569L75.0971 36.5116Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M80.1177 45.8959C80.4135 46.0894 80.6596 46.3498 80.8359 46.6562C81.0123 46.9626 81.114 47.3062 81.1327 47.6593C81.1327 48.3035 80.6743 48.5655 80.1122 48.238L73.1051 44.1926C72.8079 44.002 72.5606 43.743 72.384 43.4371C72.2074 43.1313 72.1066 42.7876 72.0901 42.4348C72.0901 41.7851 72.5485 41.5231 73.1106 41.8506L80.1177 45.8959Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M90.148 45.2135C90.4435 45.4061 90.6893 45.6656 90.8657 45.9711C91.042 46.2765 91.1439 46.6192 91.1631 46.9714C91.1631 47.6211 90.6992 47.8831 90.1371 47.5555L80.1286 41.7742C79.8332 41.5816 79.5873 41.3221 79.411 41.0166C79.2346 40.7112 79.1327 40.3685 79.1135 40.0163C79.1135 39.3667 79.5719 39.1046 80.134 39.4322L90.148 45.2135Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99.2016 50.4435C99.4981 50.6363 99.7446 50.8966 99.921 51.2031C100.097 51.5096 100.199 51.8536 100.217 52.2068C100.217 52.851 99.7583 53.1131 99.1962 52.7855L97.559 51.852C97.2626 51.6592 97.016 51.3989 96.8396 51.0924C96.6632 50.7859 96.5618 50.4419 96.5439 50.0886C96.5439 49.4444 97.0024 49.1824 97.5645 49.5099L99.2016 50.4435Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M128.753 67.5147C129.05 67.706 129.297 67.9651 129.474 68.2707C129.652 68.5763 129.754 68.9196 129.773 69.2725C129.773 69.9222 129.315 70.1842 128.747 69.8567L116.07 62.5358C115.774 62.3427 115.528 62.0823 115.351 61.7759C115.175 61.4694 115.073 61.1256 115.055 60.7725C115.055 60.1228 115.513 59.8662 116.075 60.1883L128.753 67.5147Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M137.43 72.5261C137.727 72.7167 137.975 72.9757 138.153 73.2814C138.33 73.5872 138.432 73.9309 138.45 74.284C138.45 74.9336 137.986 75.1902 137.424 74.8681L132.944 72.2804C132.648 72.087 132.402 71.8265 132.226 71.5201C132.049 71.2138 131.947 70.8701 131.929 70.5171C131.929 69.8729 132.387 69.6109 132.949 69.9384L137.43 72.5261Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M91.1739 52.2831C91.4713 52.4749 91.7185 52.735 91.8951 53.0417C92.0716 53.3484 92.1724 53.6929 92.189 54.0464C92.189 54.6906 91.7305 54.9527 91.1685 54.6251L86.9718 52.2067C86.676 52.0132 86.4299 51.7528 86.2536 51.4464C86.0772 51.14 85.9755 50.7964 85.9568 50.4434C85.9568 49.7992 86.4152 49.5371 86.9827 49.8592L91.1739 52.2831Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M105.57 60.5978C105.867 60.7906 106.113 61.0509 106.29 61.3574C106.466 61.6639 106.567 62.0079 106.585 62.3611C106.585 63.0053 106.127 63.2674 105.565 62.9398L102.23 61.0127C101.933 60.822 101.685 60.5631 101.507 60.2573C101.33 59.9516 101.228 59.6079 101.21 59.2548C101.21 58.6106 101.668 58.3431 102.236 58.6707L105.57 60.5978Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M143.989 82.7896C144.286 82.9802 144.534 83.2393 144.71 83.5451C144.887 83.851 144.988 84.1947 145.004 84.5475C145.004 85.1971 144.546 85.4592 143.984 85.1316L133.784 79.2411C133.488 79.0483 133.241 78.788 133.065 78.4815C132.888 78.175 132.787 77.831 132.769 77.4778C132.769 76.8336 133.227 76.5715 133.79 76.8991L143.989 82.7896Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M154.669 88.953C154.965 89.1464 155.211 89.4069 155.387 89.7133C155.564 90.0196 155.665 90.3633 155.684 90.7164C155.684 91.366 155.226 91.6226 154.663 91.3005L150.658 88.9857C150.361 88.793 150.115 88.5326 149.938 88.2261C149.762 87.9196 149.661 87.5757 149.643 87.2224C149.643 86.5782 150.101 86.3162 150.663 86.6437L154.669 88.953Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M154.56 127.861C154.856 128.053 155.102 128.313 155.279 128.618C155.455 128.924 155.557 129.267 155.575 129.619C155.575 130.263 155.116 130.525 154.549 130.203L150.549 127.889C150.252 127.697 150.006 127.438 149.829 127.132C149.653 126.826 149.552 126.483 149.534 126.131C149.534 125.481 149.992 125.219 150.554 125.547L154.56 127.861Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M68.139 77.9471C68.4344 78.1397 68.6803 78.3992 68.8566 78.7047C69.033 79.0101 69.1349 79.3528 69.154 79.705C69.154 80.3546 68.6956 80.6167 68.1281 80.2891L64.1279 77.9744C63.8318 77.7821 63.5851 77.5228 63.4078 77.2174C63.2305 76.912 63.1276 76.5691 63.1074 76.2166C63.1074 75.5669 63.5713 75.3103 64.1334 75.6324L68.139 77.9471Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M144.595 122.107C144.892 122.298 145.139 122.557 145.315 122.863C145.492 123.169 145.593 123.512 145.61 123.865C145.61 124.515 145.152 124.771 144.589 124.449L140.584 122.134C140.288 121.942 140.043 121.682 139.866 121.377C139.69 121.071 139.588 120.729 139.569 120.377C139.569 119.727 140.027 119.465 140.589 119.792L144.595 122.107Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M126.892 85.5355C127.188 85.7287 127.434 85.9891 127.61 86.2955C127.787 86.602 127.888 86.9458 127.907 87.2989C127.907 87.9431 127.448 88.2051 126.886 87.8776L118.4 82.9643C118.104 82.7715 117.857 82.5112 117.681 82.2046C117.504 81.8981 117.403 81.5542 117.385 81.2009C117.385 80.5513 117.843 80.2947 118.406 80.6168L126.892 85.5355Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M135.126 90.2961C135.423 90.4888 135.669 90.7492 135.846 91.0557C136.022 91.3622 136.124 91.7061 136.142 92.0594C136.142 92.7036 135.683 92.9656 135.121 92.6435L131.066 90.3015C130.771 90.109 130.525 89.8494 130.349 89.544C130.172 89.2386 130.07 88.8958 130.051 88.5436C130.051 87.894 130.51 87.632 131.072 87.954L135.126 90.2961Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M150.631 99.2438C150.926 99.4373 151.173 99.6978 151.349 100.004C151.525 100.311 151.627 100.654 151.646 101.007C151.646 101.651 151.187 101.913 150.62 101.591L144.808 98.2339C144.512 98.0408 144.265 97.7804 144.089 97.4739C143.913 97.1675 143.811 96.8237 143.793 96.4705C143.793 95.8209 144.251 95.5588 144.813 95.8864L150.631 99.2438Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M83.8559 73.4052C84.1529 73.5965 84.4003 73.8556 84.5777 74.1612C84.7551 74.4668 84.8575 74.8102 84.8764 75.1631C84.8764 75.8127 84.4125 76.0693 83.8505 75.7472L77.5583 72.1113C77.2629 71.9188 77.017 71.6592 76.8406 71.3538C76.6643 71.0484 76.5624 70.7056 76.5432 70.3534C76.5432 69.7038 77.0016 69.4418 77.5692 69.7693L83.8559 73.4052Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M93.9627 79.252C94.2589 79.4443 94.5055 79.7037 94.6828 80.0091C94.8601 80.3145 94.963 80.6573 94.9832 81.0099C94.9832 81.6596 94.5194 81.9216 93.9573 81.5941L89.3732 78.9463C89.0778 78.7538 88.8319 78.4942 88.6556 78.1888C88.4792 77.8834 88.3773 77.5406 88.3582 77.1884C88.3582 76.5388 88.822 76.2767 89.3841 76.6043L93.9627 79.252Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M105.499 85.9122C105.796 86.105 106.042 86.3653 106.219 86.6718C106.395 86.9783 106.496 87.3223 106.514 87.6756C106.514 88.3198 106.056 88.5818 105.494 88.2543L99.4909 84.7876C99.1958 84.5947 98.9501 84.3351 98.7738 84.0298C98.5975 83.7244 98.4954 83.3818 98.4758 83.0297C98.4758 82.3801 98.9342 82.118 99.5018 82.4456L105.499 85.9122Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M128.665 99.2929C128.962 99.4857 129.208 99.746 129.385 100.053C129.561 100.359 129.662 100.703 129.68 101.056C129.68 101.701 129.222 101.963 128.66 101.635L125.467 99.7898C125.171 99.5981 124.923 99.3389 124.746 99.0334C124.569 98.7278 124.466 98.3846 124.447 98.0319C124.447 97.3822 124.911 97.1256 125.473 97.4477L128.665 99.2929Z",
    fill: "#00FF9D"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.28
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M142.63 107.362C142.926 107.554 143.173 107.813 143.35 108.119C143.528 108.424 143.631 108.767 143.651 109.12C143.651 109.769 143.187 110.026 142.625 109.704L135.094 105.336C134.799 105.143 134.553 104.884 134.377 104.578C134.201 104.273 134.098 103.931 134.079 103.578C134.079 102.929 134.537 102.667 135.099 102.994L142.63 107.362Z",
    fill: "#00FF9D"
  })))), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M62.9164 34.4915C63.2141 34.6822 63.4619 34.9412 63.6394 35.2469C63.8169 35.5526 63.9189 35.8963 63.9369 36.2494C63.9369 36.8936 63.4731 37.1611 62.911 36.8336L57.29 33.558C56.9929 33.3655 56.7455 33.1054 56.5682 32.7989C56.3908 32.4924 56.2885 32.1483 56.2695 31.7947C56.2695 31.1505 56.7279 30.8884 57.2955 31.216L62.9164 34.4915Z",
    fill: "#00FF9D"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M70.9277 39.1154C71.2231 39.308 71.469 39.5676 71.6453 39.873C71.8217 40.1784 71.9236 40.5211 71.9428 40.8733C71.9428 41.523 71.4844 41.785 70.9223 41.4575L67.0094 39.2028C66.7142 39.0087 66.4686 38.7481 66.2923 38.4419C66.116 38.1356 66.014 37.7923 65.9944 37.4395C65.9944 36.7898 66.4528 36.5332 67.0149 36.8553L70.9277 39.1154Z",
    fill: "#00FF9D"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9592 48.5001C76.2553 48.6923 76.502 48.9517 76.6793 49.2571C76.8566 49.5625 76.9595 49.9053 76.9797 50.2579C76.9797 50.9076 76.5159 51.1642 75.9538 50.8421L68.9467 46.7968C68.6509 46.6033 68.4048 46.3429 68.2284 46.0365C68.0521 45.7301 67.9504 45.3865 67.9316 45.0334C67.9316 44.3892 68.39 44.1272 68.9521 44.4493L75.9592 48.5001Z",
    fill: "#00FF9D"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M86.0113 47.8122C86.3078 48.005 86.5543 48.2653 86.7307 48.5718C86.9072 48.8783 87.0085 49.2223 87.0264 49.5755C87.0264 50.2197 86.568 50.4818 86.0059 50.1597L75.9973 44.3783C75.7002 44.1858 75.4528 43.9257 75.2754 43.6192C75.0981 43.3127 74.9957 42.9686 74.9768 42.615C74.9768 41.9708 75.4352 41.7087 76.0028 42.0308L86.0113 47.8122Z",
    fill: "#00FF9D"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M95.0486 53.0475C95.3446 53.2394 95.591 53.4988 95.7674 53.8043C95.9438 54.1099 96.0454 54.453 96.0637 54.8054C96.0637 55.4496 95.6053 55.7171 95.0377 55.3895L93.4006 54.4505C93.1051 54.258 92.8593 53.9984 92.6829 53.693C92.5066 53.3876 92.4047 53.0448 92.3855 52.6926C92.3855 52.043 92.8439 51.7864 93.4115 52.1085L95.0486 53.0475Z",
    fill: "#00FF9D"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M124.6 70.1295C124.896 70.3223 125.143 70.5826 125.319 70.8891C125.495 71.1956 125.597 71.5396 125.615 71.8928C125.615 72.537 125.156 72.7991 124.594 72.4715L111.917 65.1507C111.62 64.9593 111.373 64.7002 111.195 64.3946C111.018 64.089 110.915 63.7456 110.896 63.3928C110.896 62.7431 111.355 62.4811 111.922 62.8086L124.6 70.1295Z",
    fill: "#00FF9D"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M133.277 75.1249C133.572 75.3183 133.819 75.5788 133.995 75.8851C134.171 76.1915 134.273 76.5352 134.292 76.8882C134.292 77.5324 133.833 77.7944 133.271 77.4669L128.791 74.8792C128.494 74.6879 128.246 74.4287 128.069 74.1231C127.892 73.8175 127.789 73.4742 127.77 73.1213C127.77 72.4716 128.229 72.2096 128.796 72.5371L133.277 75.1249Z",
    fill: "#00FF9D"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M87.0211 54.8873C87.3165 55.0799 87.5623 55.3394 87.7387 55.6448C87.9151 55.9503 88.0169 56.293 88.0361 56.6452C88.0361 57.2948 87.5777 57.5514 87.0101 57.2293L82.819 54.8054C82.523 54.6135 82.2767 54.3541 82.1002 54.0485C81.9238 53.743 81.8223 53.4 81.804 53.0476C81.804 52.3979 82.2624 52.1359 82.8245 52.4634L87.0211 54.8873Z",
    fill: "#00FF9D"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M101.417 63.2017C101.713 63.3943 101.958 63.6538 102.135 63.9592C102.311 64.2647 102.413 64.6074 102.432 64.9596C102.432 65.6092 101.974 65.8658 101.412 65.5437L98.0719 63.6166C97.7761 63.4232 97.53 63.1627 97.3537 62.8563C97.1773 62.55 97.0756 62.2063 97.0569 61.8533C97.0569 61.2091 97.5153 60.947 98.0774 61.2746L101.417 63.2017Z",
    fill: "#00FF9D"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M139.836 85.4155C140.132 85.6089 140.378 85.8694 140.554 86.1758C140.731 86.4822 140.832 86.8258 140.851 87.1788C140.851 87.823 140.393 88.0851 139.831 87.7575L129.626 81.867C129.33 81.6751 129.083 81.4157 128.907 81.1101C128.73 80.8046 128.629 80.4615 128.611 80.1091C128.611 79.4595 129.074 79.2029 129.637 79.525L139.836 85.4155Z",
    fill: "#00FF9D"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M150.51 91.5572C150.808 91.7478 151.055 92.0069 151.232 92.3127C151.408 92.6186 151.509 92.9623 151.526 93.3151C151.526 93.9647 151.067 94.2268 150.505 93.8992L146.499 91.5845C146.203 91.3926 145.957 91.1332 145.781 90.8277C145.604 90.5221 145.503 90.1791 145.484 89.8267C145.484 89.1825 145.948 88.9204 146.51 89.2425L150.51 91.5572Z",
    fill: "#00FF9D"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M150.407 130.46C150.703 130.653 150.95 130.913 151.126 131.219C151.303 131.526 151.404 131.87 151.422 132.223C151.422 132.867 150.963 133.129 150.401 132.802L146.396 130.493C146.1 130.299 145.854 130.039 145.677 129.732C145.501 129.426 145.399 129.082 145.381 128.729C145.381 128.08 145.839 127.823 146.401 128.145L150.407 130.46Z",
    fill: "#00FF9D"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M63.9807 80.5458C64.2772 80.7389 64.5241 80.9992 64.7014 81.3055C64.8787 81.6119 64.9814 81.9557 65.0012 82.3091C65.0012 82.9533 64.5373 83.2153 63.9752 82.8878L59.9696 80.5785C59.6738 80.3851 59.4277 80.1246 59.2514 79.8182C59.075 79.5119 58.9733 79.1682 58.9546 78.8152C58.9546 78.171 59.413 77.9089 59.9751 78.231L63.9807 80.5458Z",
    fill: "#00FF9D"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M140.442 124.722C140.738 124.916 140.984 125.176 141.16 125.482C141.336 125.789 141.438 126.132 141.457 126.485C141.457 127.13 140.993 127.392 140.431 127.064L136.431 124.755C136.133 124.563 135.886 124.303 135.71 123.996C135.533 123.69 135.432 123.345 135.416 122.992C135.416 122.347 135.874 122.085 136.436 122.413L140.442 124.722Z",
    fill: "#00FF9D"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M122.733 88.1452C123.03 88.3384 123.276 88.5986 123.454 88.905C123.631 89.2113 123.734 89.5551 123.754 89.9085C123.754 90.5527 123.29 90.8148 122.728 90.4927L114.242 85.5793C113.946 85.3868 113.7 85.1273 113.524 84.8218C113.348 84.5164 113.246 84.1737 113.227 83.8215C113.227 83.1718 113.685 82.9098 114.247 83.2319L122.733 88.1452Z",
    fill: "#00FF9D"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M130.979 92.9002C131.276 93.0915 131.523 93.3506 131.701 93.6562C131.878 93.9618 131.981 94.3052 131.999 94.6581C131.999 95.3077 131.536 95.5698 130.973 95.2422L126.924 92.9056C126.628 92.7125 126.382 92.4521 126.205 92.1457C126.029 91.8392 125.928 91.4954 125.909 91.1423C125.909 90.4926 126.368 90.2306 126.93 90.5581L130.979 92.9002Z",
    fill: "#00FF9D"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M146.472 101.842C146.768 102.035 147.015 102.296 147.191 102.602C147.367 102.909 147.469 103.253 147.487 103.606C147.487 104.255 147.029 104.517 146.467 104.19L140.649 100.832C140.354 100.64 140.109 100.38 139.932 100.075C139.756 99.7692 139.654 99.4266 139.634 99.0745C139.634 98.4249 140.093 98.1628 140.66 98.4849L146.472 101.842Z",
    fill: "#00FF9D"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M79.7028 76.0146C79.9979 76.2075 80.2435 76.4671 80.4199 76.7725C80.5962 77.0778 80.6983 77.4204 80.7179 77.7725C80.7179 78.4221 80.2595 78.6842 79.6974 78.3566L73.4052 74.7262C73.1078 74.5344 72.8606 74.2744 72.684 73.9676C72.5075 73.6609 72.4067 73.3164 72.3901 72.9629C72.3901 72.3187 72.8485 72.0566 73.4106 72.3787L79.7028 76.0146Z",
    fill: "#00FF9D"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M89.8314 81.8507C90.1272 82.0441 90.3733 82.3046 90.5496 82.611C90.726 82.9173 90.8277 83.261 90.8464 83.614C90.8464 84.2582 90.388 84.5203 89.8259 84.1982L85.2418 81.5504C84.9454 81.3576 84.6989 81.0973 84.5224 80.7908C84.346 80.4843 84.2447 80.1403 84.2268 79.7871C84.2268 79.1429 84.6852 78.8809 85.2473 79.203L89.8314 81.8507Z",
    fill: "#00FF9D"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M101.346 88.5163C101.646 88.7065 101.896 88.9649 102.076 89.2705C102.256 89.5761 102.361 89.9201 102.383 90.2742C102.383 90.9239 101.919 91.1805 101.357 90.8584L95.3541 87.3863C95.0553 87.1974 94.8068 86.9387 94.63 86.6325C94.4532 86.3263 94.3534 85.9817 94.3391 85.6284C94.3391 84.9842 94.7975 84.7222 95.3596 85.0443L101.346 88.5163Z",
    fill: "#00FF9D"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M124.507 101.892C124.804 102.084 125.051 102.345 125.228 102.651C125.405 102.957 125.508 103.301 125.527 103.655C125.527 104.305 125.069 104.561 124.501 104.239L121.309 102.394C121.013 102.2 120.767 101.94 120.59 101.634C120.414 101.327 120.312 100.984 120.294 100.63C120.294 99.9863 120.752 99.7243 121.314 100.052L124.507 101.892Z",
    fill: "#00FF9D"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M138.477 109.982C138.773 110.176 139.019 110.436 139.196 110.742C139.372 111.049 139.474 111.392 139.492 111.746C139.492 112.39 139.034 112.652 138.472 112.324L130.941 107.957C130.644 107.764 130.396 107.504 130.219 107.198C130.042 106.891 129.939 106.547 129.92 106.193C129.92 105.549 130.384 105.287 130.946 105.609L138.477 109.982Z",
    fill: "#00FF9D"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M175.259 41.4794C175.94 41.9225 176.507 42.5205 176.913 43.2245C177.319 43.9285 177.552 44.7185 177.595 45.5301L177.535 67.4655C177.535 68.9504 176.476 69.5509 175.183 68.8084L137.599 47.1024C136.917 46.6577 136.351 46.0588 135.944 45.3541C135.537 44.6494 135.302 43.8587 135.258 43.0462L135.318 23.5785C135.318 22.0881 136.376 21.4876 137.67 22.2355L162.336 36.4842C162.511 36.6093 162.715 36.6863 162.929 36.7074C163.142 36.7285 163.358 36.6929 163.553 36.6043L164.508 36.0583C164.772 35.9422 165.062 35.8967 165.349 35.9264C165.636 35.956 165.911 36.0598 166.145 36.2276L175.259 41.4794ZM176.896 67.1052L176.962 45.1699C176.927 44.5741 176.754 43.9947 176.455 43.478C176.157 42.9613 175.742 42.5218 175.243 42.1946L166.156 36.9482C165.983 36.8211 165.779 36.7425 165.565 36.7205C165.351 36.6984 165.135 36.7336 164.939 36.8226L163.979 37.3685C163.715 37.4847 163.425 37.5302 163.138 37.5005C162.851 37.4709 162.577 37.3671 162.342 37.1993L137.681 22.9561C136.731 22.4102 135.956 22.8469 135.951 23.9388L135.896 43.412C135.931 44.0068 136.105 44.5851 136.404 45.1008C136.702 45.6164 137.117 46.0551 137.615 46.3818L175.194 68.0878C176.143 68.6337 176.918 68.1915 176.918 67.1052",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "screen"
    },
    d: "M178.97 39.4594C179.56 39.8451 180.05 40.3644 180.402 40.9753C180.754 41.5861 180.957 42.2712 180.995 42.9751V43.1007L180.935 64.905C180.935 66.1988 180.018 66.7175 178.893 66.0733L141.315 44.3672C140.723 43.9834 140.23 43.4646 139.877 42.8535C139.525 42.2424 139.322 41.5563 139.285 40.8515L139.339 21.3838C139.339 20.0954 140.256 19.5713 141.38 20.221L166.042 34.4641C166.248 34.6127 166.49 34.7045 166.742 34.7304C166.995 34.7563 167.25 34.7153 167.482 34.6116L168.437 34.0656C168.669 33.9619 168.925 33.9209 169.177 33.9468C169.43 33.9726 169.672 34.0645 169.878 34.213L178.97 39.4594Z",
    fill: "url(#paint74_linear_1148_2557)"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M145.686 30.7465L145.675 33.1158L143.618 31.9257L143.623 29.5564L145.686 30.7465Z",
    fill: "white"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M145.697 27.3508L145.686 29.7255L143.623 28.5354L143.629 26.1606L145.697 27.3508Z",
    fill: "white"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M148.873 29.1907L148.868 31.56L146.805 30.3699L146.81 27.9951L148.873 29.1907Z",
    fill: "white"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M152.044 34.4207L152.038 36.79L149.976 35.5999L149.981 33.2251L152.044 34.4207Z",
    fill: "white"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M152.055 31.0248L152.044 33.3942L149.981 32.204L149.992 29.8347L152.055 31.0248Z",
    fill: "white"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M155.215 39.6507L155.204 42.02L153.146 40.8244L153.152 38.4551L155.215 39.6507Z",
    fill: "white"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M155.22 36.2548L155.214 38.6241L153.152 37.434L153.163 35.0647L155.22 36.2548Z",
    fill: "white"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M155.231 32.8593L155.225 35.2341L153.163 34.044L153.168 31.6692L155.231 32.8593Z",
    fill: "white"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M158.402 38.0947L158.396 40.4641L156.333 39.274L156.339 36.8992L158.402 38.0947Z",
    fill: "white"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M158.413 34.6989L158.407 37.0682L156.344 35.8781L156.35 33.5088L158.413 34.6989Z",
    fill: "white"
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M161.583 39.9291L161.572 42.2985L159.515 41.1083L159.52 38.739L161.583 39.9291Z",
    fill: "white"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M161.594 36.5334L161.583 38.9082L159.52 37.7126L159.526 35.3433L161.594 36.5334Z",
    fill: "white"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M164.748 45.159L164.743 47.5283L162.68 46.3382L162.691 43.9634L164.748 45.159Z",
    fill: "white"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M164.759 41.7634L164.754 44.1381L162.691 42.9426L162.696 40.5732L164.759 41.7634Z",
    fill: "white"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M164.77 38.3731L164.765 40.7424L162.702 39.5523L162.707 37.1775L164.77 38.3731Z",
    fill: "white"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M167.952 40.2075L167.941 42.5768L165.878 41.3867L165.889 39.0173L167.952 40.2075Z",
    fill: "white"
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M171.128 42.0417L171.122 44.4165L169.06 43.2263L169.065 40.8516L171.128 42.0417Z",
    fill: "white"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M174.282 54.0576L174.277 56.4269L172.208 55.2368L172.219 52.8674L174.282 54.0576Z",
    fill: "white"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M174.288 50.6674L174.282 53.0367L172.219 51.8466L172.225 49.4773L174.288 50.6674Z",
    fill: "white"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M174.299 47.2717L174.293 49.6464L172.23 48.4509L172.236 46.0815L174.299 47.2717Z",
    fill: "white"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M174.31 43.8814L174.304 46.2507L172.241 45.0606L172.247 42.6858L174.31 43.8814Z",
    fill: "white"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M177.491 45.7158L177.48 48.0851L175.417 46.895L175.423 44.5256L177.491 45.7158Z",
    fill: "white"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M148.862 32.5807L148.857 34.9555L146.794 33.7599L146.799 31.3906L148.862 32.5807Z",
    fill: "white"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M167.941 43.5976L167.935 45.9724L165.867 44.7822L165.878 42.4075L167.941 43.5976Z",
    fill: "white"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M171.09 55.6135L171.084 57.9882L169.021 56.7927L169.027 54.4233L171.09 55.6135Z",
    fill: "white"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M171.101 52.2232L171.095 54.5925L169.032 53.4024L169.038 51.0276L171.101 52.2232Z",
    fill: "white"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M171.111 48.833L171.106 51.2023L169.043 50.0068L169.049 47.6375L171.111 48.833Z",
    fill: "white"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M171.122 45.4374L171.117 47.8067L169.049 46.6166L169.06 44.2473L171.122 45.4374Z",
    fill: "white"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M177.458 55.8918L177.453 58.2666L175.39 57.0764L175.395 54.7017L177.458 55.8918Z",
    fill: "white"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M177.469 52.5016L177.464 54.871L175.401 53.6808L175.406 51.3115L177.469 52.5016Z",
    fill: "white"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M177.48 49.1114L177.469 51.4807L175.412 50.2906L175.417 47.9158L177.48 49.1114Z",
    fill: "white"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M145.664 37.5322L145.659 39.9016L143.596 38.7115L143.602 36.3367L145.664 37.5322Z",
    fill: "white"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M145.675 34.1421L145.67 36.5114L143.607 35.3159L143.612 32.9465L145.675 34.1421Z",
    fill: "white"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M148.851 35.9765L148.846 38.3458L146.783 37.1557L146.794 34.7864L148.851 35.9765Z",
    fill: "white"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M152.017 44.5966L152.006 46.9659L149.943 45.7758L149.948 43.4065L152.017 44.5966Z",
    fill: "white"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M152.022 41.2009L152.017 43.5756L149.954 42.3855L149.959 40.0107L152.022 41.2009Z",
    fill: "white"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M152.033 37.8107L152.027 40.18L149.965 38.9899L149.97 36.6206L152.033 37.8107Z",
    fill: "white"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M158.374 48.2707L158.369 50.64L156.306 49.4499L156.311 47.0806L158.374 48.2707Z",
    fill: "white"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M158.385 44.8749L158.374 47.2497L156.312 46.0541L156.322 43.6848L158.385 44.8749Z",
    fill: "white"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M158.396 41.4848L158.385 43.8541L156.323 42.664L156.328 40.2947L158.396 41.4848Z",
    fill: "white"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M161.572 43.3193L161.567 45.6886L159.504 44.4985L159.509 42.1292L161.572 43.3193Z",
    fill: "white"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M167.919 50.3835L167.913 52.7583L165.851 51.5627L165.856 49.1934L167.919 50.3835Z",
    fill: "white"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M167.93 46.9933L167.924 49.3627L165.862 48.1725L165.867 45.8032L167.93 46.9933Z",
    fill: "white"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M148.846 39.3666L148.84 41.7359L146.772 40.5458L146.783 38.1765L148.846 39.3666Z",
    fill: "white"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M155.193 46.4308L155.187 48.8056L153.125 47.6155L153.13 45.2407L155.193 46.4308Z",
    fill: "white"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M155.204 43.0407L155.198 45.41L153.135 44.2199L153.141 41.8506L155.204 43.0407Z",
    fill: "white"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.47,
    d: "M161.556 50.1049L161.545 52.4797L159.482 51.2841L159.488 48.9148L161.556 50.1049Z",
    fill: "white"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M161.561 46.7149L161.556 49.0842L159.493 47.8941L159.499 45.5193L161.561 46.7149Z",
    fill: "white"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M164.732 51.9391L164.726 54.3139L162.664 53.1238L162.669 50.749L164.732 51.9391Z",
    fill: "white"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M164.743 48.549L164.737 50.9183L162.669 49.7282L162.68 47.3589L164.743 48.549Z",
    fill: "white"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M145.654 40.9225L145.648 43.2973L143.585 42.1072L143.591 39.7324L145.654 40.9225Z",
    fill: "white"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M148.835 42.7622L148.83 45.1315L146.767 43.9414L146.772 41.5667L148.835 42.7622Z",
    fill: "white"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M167.914 53.779L167.903 56.1483L165.84 54.9582L165.845 52.5889L167.914 53.779Z",
    fill: "white"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M174.271 57.4531L174.266 59.8225L172.203 58.6323L172.208 56.2576L174.271 57.4531Z",
    fill: "white"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M177.453 59.2875L177.442 61.6569L175.379 60.4667L175.384 58.0974L177.453 59.2875Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M159.684 160.393L159.679 157.532L162.162 156.097L162.173 158.952L159.684 160.393Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M156.017 162.511L156.006 159.651L158.494 158.215L158.5 161.075L156.017 162.511Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M152.35 164.629L152.339 161.769L154.827 160.333L154.833 163.194L152.35 164.629Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M148.677 166.748L148.671 163.887L151.154 162.451L151.165 165.312L148.677 166.748Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M145.01 168.866L144.999 166.011L147.487 164.575L147.493 167.43L145.01 168.866Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M141.337 170.984L141.332 168.129L143.815 166.693L143.825 169.548L141.337 170.984Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M137.67 173.108L137.659 170.247L140.147 168.811L140.158 171.672L137.67 173.108Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M134.002 175.226L133.991 172.365L136.48 170.929L136.485 173.79L134.002 175.226Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M159.673 155.938L159.662 153.078L162.151 151.642L162.156 154.503L159.673 155.938Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M156.006 158.056L155.995 155.196L158.484 153.76L158.489 156.621L156.006 158.056Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M152.333 160.175L152.328 157.319L154.811 155.884L154.822 158.739L152.333 160.175Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M148.666 162.298L148.655 159.438L151.144 158.002L151.154 160.862L148.666 162.298Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M144.993 164.416L144.988 161.556L147.471 160.12L147.482 162.981L144.993 164.416Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M141.326 166.535L141.315 163.674L143.804 162.238L143.815 165.099L141.326 166.535Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M137.659 168.653L137.648 165.792L140.136 164.356L140.142 167.217L137.659 168.653Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M133.986 170.771L133.98 167.91L136.464 166.475L136.474 169.335L133.986 170.771Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M159.657 151.483L159.651 148.628L162.14 147.193L162.145 150.048L159.657 151.483Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M155.99 153.607L155.984 150.746L158.467 149.311L158.478 152.171L155.99 153.607Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M152.322 155.725L152.312 152.865L154.8 151.429L154.811 154.29L152.322 155.725Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M148.655 157.844L148.644 154.983L151.133 153.547L151.138 156.408L148.655 157.844Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M144.982 159.962L144.971 157.107L147.46 155.671L147.471 158.526L144.982 159.962Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M141.315 162.08L141.304 159.225L143.793 157.789L143.798 160.644L141.315 162.08Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M137.642 164.198L137.637 161.343L140.12 159.907L140.131 162.762L137.642 164.198Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M133.975 166.322L133.969 163.461L136.453 162.025L136.463 164.886L133.975 166.322Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M159.646 147.034L159.64 144.179L162.123 142.738L162.134 145.598L159.646 147.034Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M155.979 149.152L155.968 146.297L158.456 144.861L158.467 147.717L155.979 149.152Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M152.311 151.271L152.301 148.415L154.789 146.98L154.794 149.835L152.311 151.271Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M148.639 153.394L148.633 150.534L151.116 149.098L151.127 151.958L148.639 153.394Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M144.971 155.512L144.96 152.652L147.449 151.216L147.454 154.077L144.971 155.512Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M141.299 157.631L141.293 154.77L143.776 153.34L143.787 156.195L141.299 157.631Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M137.631 159.749L137.626 156.894L140.109 155.458L140.12 158.313L137.631 159.749Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M133.964 161.867L133.953 159.012L136.442 157.576L136.447 160.431L133.964 161.867Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M159.635 142.579L159.624 139.724L162.113 138.288L162.118 141.144L159.635 142.579Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M155.968 144.703L155.957 141.842L158.445 140.407L158.451 143.267L155.968 144.703Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M152.295 146.821L152.29 143.961L154.773 142.525L154.784 145.386L152.295 146.821Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M148.628 148.94L148.617 146.079L151.105 144.643L151.116 147.504L148.628 148.94Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M144.955 151.058L144.95 148.203L147.438 146.767L147.444 149.622L144.955 151.058Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M141.288 153.176L141.277 150.321L143.765 148.885L143.776 151.74L141.288 153.176Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M137.621 155.294L137.61 152.439L140.098 151.003L140.104 153.858L137.621 155.294Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M133.948 157.418L133.942 154.557L136.431 153.121L136.436 155.982L133.948 157.418Z",
    fill: "#10E9FF"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M159.684 134.773L159.679 131.912L162.162 130.476L162.173 133.337L159.684 134.773Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M156.017 136.891L156.006 134.03L158.494 132.594L158.5 135.455L156.017 136.891Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M152.35 139.009L152.339 136.148L154.827 134.713L154.833 137.573L152.35 139.009Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M148.677 141.127L148.671 138.267L151.154 136.831L151.165 139.691L148.677 141.127Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M145.01 143.245L144.999 140.39L147.487 138.954L147.493 141.81L145.01 143.245Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M141.337 145.364L141.332 142.508L143.815 141.073L143.825 143.928L141.337 145.364Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M137.67 147.487L137.659 144.627L140.147 143.191L140.158 146.051L137.67 147.487Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M134.002 149.605L133.991 146.745L136.48 145.309L136.485 148.17L134.002 149.605Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M159.673 130.318L159.662 127.457L162.151 126.021L162.156 128.882L159.673 130.318Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M156.006 132.436L155.995 129.575L158.484 128.14L158.489 131L156.006 132.436Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M152.333 134.554L152.328 131.699L154.811 130.258L154.822 133.118L152.333 134.554Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M148.666 136.678L148.655 133.817L151.144 132.381L151.154 135.242L148.666 136.678Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M144.993 138.796L144.988 135.935L147.471 134.5L147.482 137.36L144.993 138.796Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M141.326 140.914L141.315 138.054L143.804 136.618L143.815 139.479L141.326 140.914Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M137.659 143.033L137.648 140.172L140.136 138.736L140.142 141.597L137.659 143.033Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M133.986 145.151L133.98 142.29L136.464 140.854L136.474 143.715L133.986 145.151Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M159.657 125.863L159.651 123.008L162.14 121.572L162.145 124.427L159.657 125.863Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M155.99 127.987L155.984 125.126L158.467 123.69L158.478 126.551L155.99 127.987Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M152.322 130.105L152.312 127.244L154.8 125.808L154.811 128.669L152.322 130.105Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M148.655 132.223L148.644 129.363L151.133 127.927L151.138 130.787L148.655 132.223Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M144.982 134.341L144.971 131.486L147.46 130.05L147.471 132.906L144.982 134.341Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M141.315 136.46L141.304 133.604L143.793 132.169L143.798 135.024L141.315 136.46Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M137.642 138.583L137.637 135.723L140.12 134.287L140.131 137.147L137.642 138.583Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M133.975 140.701L133.969 137.841L136.453 136.405L136.463 139.266L133.975 140.701Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M159.646 121.414L159.64 118.559L162.123 117.117L162.134 119.978L159.646 121.414Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M155.979 123.532L155.968 120.677L158.456 119.241L158.467 122.096L155.979 123.532Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M152.311 125.65L152.301 122.795L154.789 121.359L154.794 124.214L152.311 125.65Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M148.639 127.774L148.633 124.913L151.116 123.477L151.127 126.333L148.639 127.774Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M144.971 129.892L144.96 127.031L147.449 125.596L147.454 128.456L144.971 129.892Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M141.299 132.01L141.293 129.15L143.776 127.714L143.787 130.575L141.299 132.01Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M137.631 134.129L137.626 131.273L140.109 129.838L140.12 132.693L137.631 134.129Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M133.964 136.247L133.953 133.391L136.442 131.956L136.447 134.811L133.964 136.247Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M159.635 116.959L159.624 114.104L162.113 112.668L162.118 115.523L159.635 116.959Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M155.968 119.083L155.957 116.222L158.445 114.786L158.451 117.647L155.968 119.083Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M152.295 121.201L152.29 118.34L154.773 116.904L154.784 119.765L152.295 121.201Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M148.628 123.319L148.617 120.458L151.105 119.023L151.116 121.883L148.628 123.319Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.19
  }, _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M144.955 125.437L144.95 122.582L147.438 121.146L147.444 124.002L144.955 125.437Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M141.288 127.556L141.277 124.7L143.765 123.265L143.776 126.12L141.288 127.556Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    }
  }, _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "M137.621 129.674L137.61 126.818L140.098 125.383L140.104 128.238L137.621 129.674Z",
    fill: "#10E9FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.4
  }, _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M133.948 131.797L133.942 128.937L136.431 127.501L136.436 130.362L133.948 131.797Z",
    fill: "#10E9FF"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.36
  }, _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M53.2679 101.591C53.5744 101.79 53.8296 102.058 54.0126 102.374C54.1957 102.69 54.3014 103.045 54.3212 103.409L54.1902 148.912C54.1902 149.578 53.7154 149.851 53.1315 149.513L6.39033 122.538C6.08487 122.339 5.83075 122.071 5.64867 121.755C5.46658 121.439 5.36168 121.085 5.34253 120.72L5.47351 75.2176C5.47351 74.5515 5.94829 74.284 6.52676 74.617L53.2679 101.591Z",
    fill: "#48FFBD"
  })))), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M18.178 114.169V115.578L17.0866 115.638C16.9941 115.393 16.9442 115.135 16.9392 114.874C16.9501 114.098 17.5013 113.804 18.178 114.169Z",
    fill: "#48FFBD"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M18.178 113.449V114.169C17.5013 113.782 16.9501 114.098 16.9501 114.874C16.9551 115.135 17.0049 115.394 17.0974 115.638H16.5517C16.4065 115.269 16.3289 114.877 16.3225 114.481C16.3225 113.334 17.1575 112.859 18.178 113.449Z",
    fill: "#48FFBD"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.1725 116.986C17.6687 116.671 17.2846 116.196 17.0811 115.638L18.1725 115.578V114.169C18.5269 114.403 18.8219 114.716 19.0341 115.084C19.2463 115.452 19.3699 115.864 19.3949 116.288C19.3949 117.079 18.8437 117.379 18.1725 116.986Z",
    fill: "#48FFBD"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "M18.178 113.449C18.6634 113.766 19.0769 114.182 19.3918 114.669C19.7067 115.156 19.916 115.704 20.0062 116.277L19.7115 116.108C19.5423 116.009 19.4004 116.108 19.4004 116.288C19.4057 116.397 19.4365 116.503 19.4906 116.598C19.5447 116.693 19.6204 116.774 19.7115 116.834L20.0007 116.997C19.8479 117.915 19.0839 118.242 18.1726 117.713C17.4145 117.231 16.8384 116.511 16.5354 115.665H17.0811C17.2847 116.224 17.6688 116.698 18.1726 117.014C18.8438 117.407 19.395 117.09 19.4004 116.315C19.3776 115.891 19.2549 115.479 19.0424 115.112C18.83 114.745 18.5338 114.433 18.178 114.202V113.449Z",
    fill: "#48FFBD"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M18.1725 117.712C19.0838 118.258 19.8478 117.914 20.0006 116.997L23.6188 119.088C23.4496 122.287 21.0648 123.527 18.1616 121.851C16.0987 120.66 14.3087 118.308 13.3865 115.845L16.5517 115.676C16.8526 116.515 17.4224 117.231 18.1725 117.712Z",
    fill: "#48FFBD"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M11.4219 111.68C11.4219 107.394 14.467 105.675 18.1943 107.815V109.311C15.1874 107.569 12.7371 108.967 12.7371 112.433C12.7521 113.597 12.9757 114.749 13.3974 115.834L12.2568 115.895C11.7314 114.55 11.4487 113.123 11.4219 111.68Z",
    fill: "#48FFBD"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M20.0061 116.277C19.9159 115.704 19.7072 115.157 19.3933 114.67C19.0794 114.183 18.6673 113.767 18.1833 113.449V109.311C21.0921 110.987 23.4605 114.977 23.6133 118.368L20.0061 116.277Z",
    fill: "#48FFBD"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M18.1889 109.311V113.449C17.1684 112.859 16.3335 113.334 16.328 114.508C16.3343 114.904 16.412 115.296 16.5572 115.665L13.392 115.834C12.9704 114.749 12.7467 113.597 12.7317 112.433C12.7317 108.967 15.182 107.569 18.1889 109.311Z",
    fill: "#48FFBD"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1562 123.346C21.7744 125.437 24.7431 123.86 24.9232 119.842L25.2397 120.022C25.0596 124.242 21.9654 125.901 18.1453 123.712C15.4767 122.167 13.1574 119.116 11.9568 115.906H12.2351C13.3866 118.957 15.6131 121.872 18.1562 123.346Z",
    fill: "#48FFBD"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1944 107.455V107.798C14.4671 105.648 11.4329 107.378 11.422 111.664C11.4436 113.106 11.7207 114.533 12.2406 115.878H11.9623C11.4161 114.471 11.126 112.977 11.1055 111.467C11.1164 107.012 14.298 105.205 18.1944 107.455Z",
    fill: "#48FFBD"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M10.6143 111.216C10.6143 106.445 14.0523 104.49 18.1998 106.887V107.433C14.3033 105.183 11.1054 106.99 11.1054 111.473C11.1259 112.982 11.4161 114.476 11.9622 115.884H11.5311C10.9547 114.393 10.6444 112.814 10.6143 111.216Z",
    fill: "#48FFBD"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M24.923 119.116C24.7702 114.906 21.8179 109.906 18.1997 107.815V107.455C22.0198 109.638 25.0922 114.89 25.245 119.301L24.923 119.116Z",
    fill: "#48FFBD"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3517 122.833C31.4448 122.892 31.5223 122.972 31.5775 123.067C31.6326 123.162 31.6638 123.269 31.6683 123.379C31.6683 123.581 31.5264 123.663 31.3517 123.559L25.2396 120.027L24.9231 119.847L23.6188 119.094L20.0007 117.003L19.7115 116.839C19.6203 116.779 19.5446 116.698 19.4905 116.603C19.4365 116.508 19.4056 116.402 19.4004 116.293C19.4004 116.097 19.5423 116.015 19.7115 116.113L20.0061 116.282L23.6188 118.373L24.9231 119.121L25.2396 119.307L31.3517 122.833Z",
    fill: "#48FFBD"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M34.8444 125.869L35.1172 126.022V126.633L34.8498 126.475V127.184L34.3041 126.862V126.153L32.9944 125.394V124.788L34.2987 123.314L34.8444 123.641V125.869ZM34.2987 125.541V124.384L33.6111 125.148L34.2987 125.541Z",
    fill: "#48FFBD"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M27.0133 103.251C27.1054 103.31 27.1822 103.391 27.2372 103.486C27.2922 103.581 27.3239 103.687 27.3298 103.797C27.3298 103.999 27.1879 104.075 27.0133 103.977L26.7022 103.797L15.7877 97.4969C15.6955 97.4374 15.6188 97.3569 15.5638 97.262C15.5087 97.1671 15.477 97.0605 15.4712 96.9509C15.4712 96.7489 15.6131 96.6725 15.7877 96.7708L26.7022 103.071L27.0133 103.251Z",
    fill: "#48FFBD"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M41.0493 108.798V109.818L39.4121 108.869L39.2048 109.802L39.374 109.857L39.5322 109.933C40.0108 110.223 40.4029 110.636 40.6673 111.129C40.9595 111.625 41.114 112.19 41.1148 112.766C41.1429 112.984 41.111 113.206 41.0225 113.407C40.934 113.608 40.7923 113.781 40.6127 113.907C40.4167 113.999 40.1995 114.036 39.9842 114.014C39.7689 113.992 39.5636 113.912 39.3903 113.782C38.951 113.516 38.5778 113.154 38.2989 112.723C37.9914 112.27 37.7848 111.756 37.6931 111.216L38.6972 111.8C38.769 112.009 38.872 112.206 39.0028 112.384C39.1162 112.538 39.259 112.668 39.4231 112.766C39.4998 112.826 39.592 112.862 39.6887 112.871C39.7855 112.88 39.8827 112.86 39.9688 112.816C40.0495 112.751 40.1124 112.667 40.1516 112.572C40.1907 112.476 40.2048 112.372 40.1925 112.27C40.1897 111.996 40.1184 111.728 39.9852 111.489C39.8731 111.263 39.6989 111.074 39.4831 110.943C39.3906 110.883 39.2822 110.853 39.172 110.856C39.0654 110.859 38.9616 110.891 38.8719 110.949L38.0915 110.299L38.7136 107.438L41.0493 108.798Z",
    fill: "#48FFBD"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9144 117.019C47.9938 117.07 48.0802 117.108 48.1709 117.134C47.587 123.024 42.9865 125.235 37.4311 122.047C31.5973 118.684 26.8495 110.583 26.7021 103.819L27.0132 103.999C27.1878 104.097 27.3243 103.999 27.3297 103.819C27.3297 110.239 31.8429 118.095 37.4311 121.321C42.6482 124.34 46.9703 122.271 47.5379 116.757C47.6529 116.859 47.7793 116.947 47.9144 117.019Z",
    fill: "#48FFBD"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.491 99.9153C42.1679 102.645 45.9443 109.163 45.9334 114.541C45.9224 119.918 42.1133 122.08 37.4364 119.383C32.7596 116.686 28.9832 110.135 28.9996 104.763C29.0159 99.3912 32.8142 97.2184 37.491 99.9153ZM36.7597 111.724C36.9366 111.621 37.079 111.468 37.1684 111.285C37.2579 111.101 37.2904 110.894 37.2618 110.692C37.2656 110.313 37.1776 109.938 37.0053 109.6C36.8336 109.234 36.5905 108.905 36.2904 108.634C36.3913 108.645 36.4933 108.631 36.5881 108.595C36.683 108.559 36.768 108.501 36.8362 108.426C36.9705 108.258 37.0367 108.046 37.0217 107.831C37.0088 107.361 36.8652 106.903 36.6069 106.51C36.3547 106.078 35.9982 105.716 35.5701 105.456C35.4082 105.329 35.2136 105.251 35.0089 105.229C34.8042 105.208 34.5977 105.245 34.4131 105.336C34.2898 105.43 34.1894 105.55 34.1194 105.688C34.0495 105.826 34.0118 105.979 34.0093 106.133L34.9316 106.679C34.9459 106.623 34.9746 106.571 35.0147 106.529C35.0549 106.487 35.1052 106.456 35.1608 106.439C35.2251 106.425 35.2915 106.425 35.3562 106.437C35.4208 106.449 35.4824 106.474 35.5373 106.51C35.6911 106.604 35.8202 106.733 35.9139 106.887C36.0029 107.03 36.0518 107.194 36.0558 107.362C36.0613 107.466 36.026 107.567 35.9575 107.646C35.9243 107.683 35.8827 107.711 35.8363 107.729C35.7898 107.747 35.7397 107.754 35.6901 107.749C35.51 107.723 35.3361 107.664 35.1772 107.575V108.519C35.519 108.71 35.8122 108.977 36.0339 109.3C36.2136 109.542 36.3163 109.833 36.3286 110.135C36.3404 110.227 36.3262 110.321 36.2876 110.406C36.2491 110.491 36.1877 110.563 36.1103 110.615C36.0208 110.652 35.923 110.665 35.8271 110.651C35.7312 110.638 35.6406 110.599 35.5646 110.539C35.3384 110.408 35.1503 110.219 35.0189 109.993C34.8701 109.743 34.7788 109.464 34.7515 109.174L33.8019 108.628C33.8243 109.222 33.997 109.801 34.304 110.31C34.5897 110.807 34.9997 111.22 35.4937 111.511C35.6733 111.647 35.8845 111.737 36.1077 111.77C36.3309 111.803 36.5589 111.78 36.7707 111.702L36.7597 111.724ZM40.5907 113.886C40.7703 113.759 40.912 113.586 41.0005 113.385C41.089 113.184 41.1209 112.962 41.0928 112.745C41.0919 112.169 40.9375 111.603 40.6453 111.107C40.3808 110.614 39.9888 110.201 39.5102 109.911L39.3519 109.835L39.1828 109.78L39.3901 108.847L41.0273 109.797V108.776L38.6698 107.416L38.0476 110.277L38.828 110.927C38.9177 110.869 39.0215 110.837 39.1282 110.834C39.2383 110.831 39.3468 110.861 39.4393 110.921C39.6551 111.052 39.8293 111.241 39.9413 111.467C40.0745 111.706 40.1458 111.974 40.1487 112.248C40.161 112.35 40.1469 112.454 40.1077 112.55C40.0686 112.645 40.0056 112.729 39.9249 112.794C39.8388 112.839 39.7416 112.858 39.6449 112.849C39.5481 112.84 39.4559 112.804 39.3792 112.745C39.2152 112.646 39.0723 112.516 38.959 112.362C38.8282 112.184 38.7251 111.987 38.6534 111.778L37.6493 111.194C37.7409 111.734 37.9475 112.248 38.255 112.701C38.534 113.132 38.9072 113.494 39.3465 113.76C39.5198 113.89 39.725 113.97 39.9403 113.992C40.1556 114.014 40.3729 113.977 40.5689 113.886",
    fill: "#48FFBD"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5433 114.208C47.0521 108.497 43.3085 102.012 38.5989 98.7034C38.6403 98.5747 38.6606 98.4401 38.6589 98.3049C38.6577 98.2024 38.6486 98.1002 38.6316 97.9991C43.6632 101.515 47.6633 108.443 48.1763 114.535C48.0971 114.467 48.0112 114.406 47.9198 114.355C47.8038 114.284 47.6764 114.235 47.5433 114.208Z",
    fill: "#48FFBD"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5593 105.478C35.9875 105.737 36.344 106.1 36.5962 106.532C36.8544 106.925 36.998 107.383 37.0109 107.853C37.0259 108.068 36.9597 108.28 36.8254 108.448C36.7572 108.523 36.6722 108.581 36.5774 108.617C36.4826 108.653 36.3805 108.667 36.2797 108.656C36.5798 108.927 36.8228 109.256 36.9946 109.622C37.1668 109.96 37.2548 110.334 37.2511 110.714C37.2796 110.916 37.2471 111.123 37.1577 111.306C37.0682 111.49 36.9259 111.643 36.749 111.746C36.5373 111.824 36.3092 111.847 36.086 111.814C35.8628 111.78 35.6517 111.691 35.472 111.555C34.978 111.264 34.568 110.85 34.2823 110.353C33.9754 109.845 33.8026 109.266 33.7803 108.672L34.7298 109.218C34.7571 109.507 34.8485 109.787 34.9972 110.037C35.1287 110.263 35.3167 110.451 35.5429 110.583C35.619 110.643 35.7096 110.681 35.8055 110.695C35.9014 110.708 35.9991 110.696 36.0887 110.659C36.166 110.607 36.2274 110.535 36.266 110.45C36.3045 110.365 36.3187 110.271 36.307 110.179C36.2946 109.877 36.1919 109.586 36.0123 109.344C35.7906 109.021 35.4973 108.754 35.1555 108.563V107.618C35.3145 107.707 35.4883 107.766 35.6685 107.793C35.7181 107.798 35.7681 107.791 35.8146 107.773C35.8611 107.755 35.9026 107.726 35.9359 107.689C36.0044 107.611 36.0396 107.509 36.0341 107.405C36.0302 107.237 35.9812 107.073 35.8922 106.93C35.7985 106.777 35.6694 106.648 35.5157 106.554C35.4607 106.518 35.3991 106.493 35.3345 106.481C35.2699 106.468 35.2035 106.469 35.1391 106.483C35.0835 106.5 35.0332 106.531 34.993 106.573C34.9529 106.615 34.9243 106.667 34.9099 106.723L33.9877 106.177C33.9901 106.022 34.0278 105.87 34.0978 105.732C34.1677 105.594 34.2682 105.474 34.3915 105.38C34.5753 105.284 34.7828 105.242 34.9897 105.259C35.1965 105.276 35.3941 105.353 35.5593 105.478Z",
    fill: "#48FFBD"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3996 97.4258C31.3244 95.1275 27.3461 97.7916 27.3297 103.791C27.3239 103.682 27.2922 103.575 27.2372 103.48C27.1821 103.385 27.1054 103.305 27.0132 103.245L26.7021 103.065C26.8822 96.94 31.0679 94.2595 36.3669 96.6834C36.347 96.7731 36.336 96.8645 36.3342 96.9564C36.3348 97.1151 36.3569 97.273 36.3996 97.4258Z",
    fill: "#48FFBD"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6757 94.598C14.0066 94.814 14.2819 95.105 14.4791 95.4475C14.6764 95.7899 14.79 96.1741 14.8108 96.5688C14.8108 97.2894 14.2979 97.5787 13.6703 97.2184C13.3392 97.004 13.0637 96.714 12.8664 96.3724C12.669 96.0307 12.5555 95.6472 12.5352 95.2531C12.5352 94.5325 13.0482 94.2377 13.6757 94.598ZM13.6757 96.4923C13.9595 96.6561 14.1833 96.5251 14.1833 96.203C14.1761 96.0264 14.1262 95.854 14.0378 95.7009C13.9494 95.5478 13.8251 95.4185 13.6757 95.3241C13.3974 95.1658 13.1682 95.2913 13.1682 95.6189C13.1792 95.7939 13.2309 95.9639 13.319 96.1155C13.407 96.2671 13.5292 96.3961 13.6757 96.4923Z",
    fill: "#48FFBD"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M21.4251 93.3096L21.4142 96.8799L13.5503 92.3378L13.5612 88.7675L21.4251 93.3096Z",
    fill: "#48FFBD"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M46.452 130.465L46.4411 134.036L38.5718 129.488L38.5827 125.918L46.452 130.465Z",
    fill: "#48FFBD"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M37.3438 125.17V125.781L36.3615 125.235L36.2414 125.781L36.3397 125.814L36.4324 125.858C36.7184 126.032 36.9536 126.279 37.1146 126.573C37.2888 126.869 37.3794 127.207 37.3765 127.55C37.3937 127.68 37.3747 127.811 37.3217 127.931C37.2688 128.05 37.1839 128.153 37.0764 128.227C36.9605 128.283 36.8315 128.305 36.7036 128.293C36.5756 128.28 36.4535 128.233 36.3506 128.156C36.0862 127.997 35.8606 127.78 35.6903 127.523C35.5076 127.251 35.3849 126.944 35.3301 126.622L35.9304 126.971C35.9714 127.097 36.0322 127.215 36.1105 127.321C36.1771 127.414 36.2626 127.492 36.3615 127.55C36.4067 127.585 36.4612 127.607 36.5184 127.612C36.5756 127.617 36.633 127.605 36.6835 127.577C36.7762 127.528 36.8199 127.414 36.8199 127.25C36.8195 127.088 36.7782 126.928 36.6998 126.786C36.6295 126.653 36.5261 126.54 36.3997 126.458C36.3436 126.425 36.2794 126.408 36.2141 126.409C36.1505 126.412 36.0886 126.431 36.0341 126.464L35.5702 126.076L35.9413 124.367L37.3438 125.17Z",
    fill: "#48FFBD"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5021 96.3012C37.7961 96.4922 38.0481 96.7413 38.2423 97.0333C38.4366 97.3253 38.5691 97.6539 38.6317 97.9991C38.6487 98.1001 38.6578 98.2023 38.659 98.3048C38.6607 98.44 38.6404 98.5746 38.599 98.7033C38.4407 99.1401 38.0041 99.2492 37.5075 98.9708C36.9618 98.6146 36.5717 98.0643 36.4161 97.4313C36.3733 97.2785 36.3513 97.1205 36.3506 96.9618C36.3524 96.87 36.3634 96.7785 36.3833 96.6889C36.4816 96.1593 36.9454 95.9791 37.5021 96.3012Z",
    fill: "#48FFBD"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M47.9201 114.35C48.0114 114.401 48.0973 114.461 48.1765 114.53C48.442 114.757 48.6586 115.036 48.8133 115.349C48.9681 115.663 49.0578 116.004 49.077 116.353C49.077 116.986 48.6895 117.298 48.1711 117.134C48.0811 117.104 47.995 117.064 47.9146 117.014C47.7783 116.934 47.6519 116.839 47.538 116.73C47.0691 116.276 46.7885 115.662 46.7522 115.01C46.7522 114.426 47.0906 114.12 47.5435 114.202C47.6766 114.229 47.8041 114.279 47.9201 114.35Z",
    fill: "#48FFBD"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M47.1777 139.402L47.1723 140.303L42.5991 137.661L42.6046 136.76L47.1777 139.402Z",
    fill: "#48FFBD"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M15.1711 84.7767V85.6775L10.5979 83.0352V82.1399L15.1711 84.7767Z",
    fill: "#48FFBD"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4039 136.072V136.967L39.0464 135.608V134.707L41.4039 136.072Z",
    fill: "#48FFBD"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.36
  }, _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M69.1704 90.3725C69.477 90.5722 69.7321 90.8413 69.9151 91.1581C70.0981 91.475 70.2038 91.8305 70.2236 92.1959L70.0926 137.699C70.0926 138.365 69.6179 138.638 69.0339 138.299L22.2873 111.298C21.9818 111.099 21.7277 110.83 21.5456 110.515C21.3636 110.199 21.2587 109.844 21.2395 109.48L21.3705 63.977C21.3705 63.311 21.8453 63.038 22.4237 63.3765L69.1704 90.3725Z",
    fill: "#48FFBD"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.61
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M34.075 102.956V104.365L32.9835 104.425C32.891 104.18 32.8412 103.922 32.8362 103.66C32.8471 102.885 33.3983 102.569 34.075 102.956Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M34.0749 102.236V102.956C33.3982 102.569 32.847 102.885 32.847 103.66C32.852 103.922 32.9018 104.18 32.9944 104.425H32.4486C32.3077 104.055 32.232 103.663 32.2249 103.267C32.2194 102.121 33.0762 101.646 34.0749 102.236Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.0695 105.773C33.5671 105.456 33.1834 104.982 32.978 104.425L34.0695 104.365V102.956C34.4256 103.188 34.7216 103.5 34.9332 103.868C35.1448 104.237 35.2659 104.65 35.2864 105.074C35.2919 105.85 34.7407 106.161 34.0695 105.773Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M34.0748 102.236C34.5595 102.553 34.9721 102.969 35.2861 103.456C35.6 103.943 35.8083 104.491 35.8976 105.063L35.6083 104.894C35.4337 104.796 35.2973 104.894 35.2918 105.074C35.2972 105.184 35.3287 105.291 35.3838 105.386C35.4388 105.481 35.5159 105.561 35.6083 105.62L35.8976 105.79C35.7448 106.707 34.9807 107.034 34.0639 106.505C33.3087 106.02 32.7334 105.301 32.4268 104.458H32.9725C33.1779 105.015 33.5616 105.489 34.0639 105.806C34.7352 106.194 35.2863 105.882 35.2863 105.107C35.2662 104.684 35.1453 104.271 34.9337 103.903C34.722 103.536 34.4257 103.224 34.0694 102.994L34.0748 102.236Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M34.064 106.499C34.9808 107.045 35.7448 106.701 35.8976 105.784L39.5158 107.875C39.3411 111.074 36.9563 112.313 34.0585 110.637C31.9957 109.447 30.2057 107.094 29.2834 104.632L32.4432 104.468C32.7487 105.303 33.3176 106.016 34.064 106.499Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M27.3135 100.467C27.3135 96.1813 30.3641 94.4616 34.0913 96.6016V98.092C31.079 96.3559 28.6341 97.7535 28.6341 101.215C28.6487 102.379 28.8723 103.531 29.2945 104.616L28.1539 104.676C27.6269 103.334 27.3423 101.909 27.3135 100.467Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M35.8977 105.069C35.8085 104.496 35.6001 103.949 35.2862 103.462C34.9722 102.974 34.5596 102.559 34.075 102.241V98.0974C36.9837 99.7789 39.3521 103.77 39.5049 107.154L35.8977 105.069Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M34.0859 98.092V102.236C33.0654 101.646 32.2304 102.121 32.225 103.295C32.2321 103.691 32.3078 104.082 32.4487 104.452L29.289 104.616C28.8669 103.531 28.6432 102.379 28.6287 101.215C28.6232 97.7535 31.0735 96.3341 34.0859 98.092Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M34.0476 112.133C37.6657 114.224 40.6399 112.646 40.8145 108.623L41.131 108.809C40.9564 113.029 37.8567 114.688 34.0366 112.494C31.3681 110.954 29.0433 107.902 27.8481 104.692H28.1265C29.2561 107.744 31.499 110.659 34.0476 112.133Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M34.0912 96.2413V96.6016C30.3639 94.4507 27.3297 96.1813 27.3134 100.467C27.337 101.908 27.616 103.333 28.1374 104.676H27.8591C27.3119 103.268 27.0199 101.775 26.9968 100.265C27.0132 95.7882 30.1948 93.9867 34.0912 96.2413Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M26.5276 99.9973C26.5276 95.2313 29.9656 93.2769 34.1131 95.6735V96.2194C30.2167 93.9648 27.0187 95.7773 27.0187 100.259C27.0418 101.769 27.3338 103.263 27.881 104.67H27.4499C26.871 103.179 26.5588 101.597 26.5276 99.9973Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M40.8201 107.902C40.6673 103.693 37.7149 98.6925 34.0913 96.6016V96.2413C37.8841 98.425 40.9838 103.677 41.1366 108.088L40.8201 107.902Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M47.2651 111.62C47.3564 111.68 47.4325 111.761 47.4874 111.856C47.5423 111.951 47.5746 112.057 47.5817 112.166C47.5817 112.368 47.4398 112.444 47.2651 112.346L41.1476 108.814L40.8311 108.628L39.5322 107.88L35.9141 105.79L35.6249 105.62C35.5324 105.561 35.4554 105.481 35.4003 105.386C35.3453 105.291 35.3137 105.184 35.3083 105.074C35.3083 104.878 35.4502 104.796 35.6249 104.894L35.9141 105.063L39.5322 107.149L40.8365 107.902L41.153 108.088L47.2651 111.62Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M50.7414 114.65L51.0088 114.808V115.442L50.7414 115.283V115.987L50.1957 115.665V114.956L48.886 114.197V113.591L50.1957 112.117L50.7414 112.444V114.65ZM50.1957 114.328V113.17L49.5081 113.935L50.1903 114.328",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M42.8994 92.0376C42.9909 92.0974 43.0668 92.1781 43.1209 92.273C43.175 92.3679 43.2057 92.4744 43.2105 92.5836C43.2105 92.7801 43.0686 92.862 42.8939 92.7637L42.5883 92.5836L31.6739 86.2836C31.5836 86.2226 31.5086 86.1416 31.4546 86.0469C31.4007 85.9523 31.3693 85.8465 31.3628 85.7377C31.3628 85.5357 31.5047 85.4592 31.6793 85.5575L42.5938 91.8575L42.8994 92.0376Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M56.9462 97.5842V98.6051L55.309 97.6552L55.1016 98.5888L55.2654 98.6433C55.3214 98.6655 55.3761 98.691 55.4291 98.7198C55.9077 99.0094 56.2997 99.4223 56.5642 99.9153C56.8547 100.412 57.009 100.977 57.0117 101.553C57.0386 101.771 57.0061 101.992 56.9177 102.193C56.8293 102.394 56.6883 102.567 56.5096 102.694C56.3132 102.786 56.0956 102.822 55.8802 102.799C55.6647 102.776 55.4597 102.694 55.2872 102.563C54.8473 102.3 54.4738 101.94 54.1958 101.509C53.8928 101.055 53.6884 100.541 53.5955 100.003L54.5996 100.581C54.668 100.794 54.7712 100.993 54.9052 101.171C55.0172 101.326 55.1603 101.456 55.3254 101.553C55.4015 101.614 55.4938 101.651 55.5909 101.66C55.6879 101.669 55.7854 101.649 55.8711 101.602C55.9526 101.539 56.0162 101.455 56.0554 101.359C56.0946 101.263 56.1082 101.159 56.0949 101.056C56.0959 100.782 56.0243 100.513 55.8875 100.276C55.775 100.052 55.6032 99.8628 55.3909 99.7297C55.2978 99.6718 55.1894 99.6433 55.0798 99.6478C54.9732 99.6508 54.8694 99.6829 54.7797 99.7406L53.9993 99.091L54.616 96.2303L56.9462 97.5842Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M63.8059 105.806C63.8878 105.855 63.9759 105.894 64.0679 105.92C63.4785 111.811 58.8835 114.022 53.3226 110.834C47.4943 107.465 42.7465 99.3694 42.5991 92.6053L42.9047 92.7855C43.0794 92.8838 43.2212 92.7855 43.2212 92.6053C43.2212 99.0254 47.7398 106.881 53.328 110.108C58.5451 113.121 62.8673 111.058 63.4348 105.544C63.5483 105.645 63.6728 105.733 63.8059 105.806Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M53.3881 88.6912C58.0649 91.4209 61.8413 97.9392 61.8249 103.317C61.8086 108.694 58.0049 110.856 53.3335 108.159C48.6621 105.462 44.8802 98.911 44.8911 93.5391C44.9021 88.1672 48.7112 86.0053 53.3881 88.6912ZM52.6568 100.5C52.8322 100.396 52.9732 100.242 53.0625 100.059C53.1517 99.8756 53.1852 99.6701 53.1588 99.4678C53.1598 99.0888 53.072 98.7148 52.9023 98.376C52.7236 98.0157 52.4772 97.6932 52.1765 97.4261C52.2774 97.4365 52.3793 97.4232 52.474 97.3871C52.5688 97.3511 52.6538 97.2934 52.7223 97.2186C52.8561 97.0503 52.9223 96.8381 52.9078 96.6236C52.8924 96.1536 52.749 95.6968 52.4931 95.3024C52.2387 94.8698 51.8805 94.5077 51.4507 94.2488C51.2894 94.1227 51.0958 94.0447 50.8922 94.0234C50.6886 94.0022 50.4831 94.0387 50.2993 94.1287C50.1752 94.2219 50.074 94.3421 50.0031 94.4801C49.9322 94.6182 49.8935 94.7705 49.89 94.9257L50.8122 95.4716C50.8271 95.4146 50.8565 95.3625 50.8977 95.3204C50.9388 95.2782 50.9903 95.2476 51.0469 95.2314C51.1103 95.2175 51.1759 95.2167 51.2397 95.2289C51.3035 95.2411 51.3641 95.2661 51.418 95.3024C51.5753 95.3916 51.7054 95.5217 51.7945 95.6791C51.8867 95.8204 51.936 95.9853 51.9364 96.154C51.9403 96.2567 51.9074 96.3574 51.8437 96.4379C51.8096 96.4737 51.7678 96.5012 51.7214 96.5183C51.675 96.5353 51.6254 96.5414 51.5762 96.5362C51.3954 96.5157 51.2208 96.4581 51.0633 96.367V97.3114C51.404 97.5035 51.6984 97.7681 51.9255 98.0866C52.1043 98.3297 52.2068 98.6204 52.2202 98.9219C52.2327 99.015 52.2183 99.1097 52.1786 99.1949C52.139 99.28 52.0758 99.352 51.9965 99.4023C51.9074 99.4399 51.8099 99.4532 51.714 99.4407C51.6181 99.4282 51.5273 99.3905 51.4507 99.3313C51.2253 99.1989 51.0374 99.0109 50.905 98.7854C50.7545 98.536 50.6613 98.2563 50.6322 97.9665L49.688 97.4206C49.7104 98.0146 49.8831 98.5931 50.1901 99.1021C50.4755 99.5977 50.8857 100.01 51.3798 100.298C51.5585 100.436 51.7695 100.527 51.9929 100.561C52.2163 100.596 52.4448 100.573 52.6568 100.494V100.5ZM56.4768 102.678C56.6556 102.551 56.7966 102.377 56.8849 102.177C56.9733 101.976 57.0058 101.755 56.9789 101.537C56.9762 100.961 56.8219 100.396 56.5314 99.8991C56.267 99.4061 55.8749 98.9931 55.3963 98.7035C55.3433 98.6748 55.2887 98.6493 55.2326 98.6271L55.0689 98.5725L55.2762 97.639L56.9134 98.5889V97.568L54.5504 96.2087L53.9338 99.0693L54.7142 99.719C54.8038 99.6612 54.9077 99.6291 55.0143 99.6262C55.1239 99.6216 55.2323 99.6501 55.3254 99.708C55.5377 99.8411 55.7095 100.03 55.822 100.254C55.9588 100.491 56.0304 100.761 56.0293 101.035C56.0427 101.137 56.0291 101.242 55.9899 101.337C55.9506 101.433 55.8871 101.517 55.8056 101.581C55.7198 101.627 55.6224 101.647 55.5254 101.638C55.4283 101.629 55.336 101.592 55.2599 101.531C55.0948 101.435 54.9516 101.305 54.8397 101.149C54.7057 100.971 54.6024 100.772 54.5341 100.56L53.5299 99.981C53.6228 100.52 53.8273 101.033 54.1302 101.488C54.4083 101.918 54.7818 102.279 55.2217 102.541C55.3942 102.673 55.5992 102.754 55.8147 102.777C56.0301 102.8 56.2477 102.764 56.4441 102.672",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M63.4404 102.994C62.9437 97.2839 59.2055 90.7983 54.4905 87.49C54.5369 87.3624 54.5591 87.2272 54.556 87.0915C54.5545 86.9872 54.5454 86.8832 54.5287 86.7803C59.5603 90.296 63.5604 97.2293 64.0734 103.322C63.9941 103.253 63.9082 103.193 63.8169 103.142C63.7009 103.071 63.5735 103.021 63.4404 102.994Z",
    fill: "#48FFBD"
  }))), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M51.4508 94.2651C51.8806 94.524 52.2388 94.8861 52.4932 95.3187C52.7491 95.7131 52.8925 96.1699 52.9079 96.6398C52.9224 96.8544 52.8562 97.0666 52.7224 97.2349C52.6539 97.3097 52.5689 97.3674 52.4741 97.4034C52.3794 97.4394 52.2775 97.4528 52.1767 97.4424C52.4751 97.7153 52.7178 98.0434 52.8915 98.4086C53.0612 98.7475 53.149 99.1215 53.148 99.5005C53.1744 99.7027 53.1409 99.9083 53.0517 100.092C52.9624 100.275 52.8214 100.428 52.646 100.532C52.4339 100.611 52.2055 100.634 51.982 100.599C51.7586 100.565 51.5477 100.474 51.369 100.336C50.8749 100.048 50.4647 99.6358 50.1793 99.1402C49.8723 98.6313 49.6996 98.0527 49.6772 97.4587L50.6213 98.0046C50.6505 98.2945 50.7437 98.5742 50.8942 98.8235C51.0266 99.0491 51.2145 99.237 51.4399 99.3695C51.5164 99.4286 51.6073 99.4663 51.7032 99.4788C51.7991 99.4913 51.8966 99.478 51.9856 99.4404C52.0649 99.3901 52.1282 99.3181 52.1678 99.233C52.2075 99.1478 52.2219 99.0531 52.2094 98.96C52.196 98.6585 52.0935 98.3678 51.9147 98.1248C51.7006 97.798 51.4175 97.5221 51.0852 97.3168V96.3723C51.2427 96.4635 51.4174 96.5211 51.5982 96.5416C51.6473 96.5468 51.697 96.5407 51.7433 96.5236C51.7897 96.5066 51.8315 96.4791 51.8656 96.4433C51.9293 96.3627 51.9622 96.2621 51.9584 96.1594C51.9579 95.9907 51.9086 95.8257 51.8165 95.6845C51.7273 95.5271 51.5972 95.3969 51.4399 95.3078C51.3861 95.2715 51.3254 95.2464 51.2617 95.2342C51.1979 95.222 51.1323 95.2229 51.0688 95.2368C51.0122 95.2529 50.9608 95.2836 50.9196 95.3257C50.8785 95.3679 50.849 95.42 50.8342 95.477L49.9119 94.9311C49.9154 94.7759 49.9541 94.6236 50.025 94.4855C50.0959 94.3475 50.1972 94.2273 50.3212 94.134C50.5033 94.0499 50.7051 94.0176 50.9044 94.0407C51.1037 94.0638 51.2928 94.1415 51.4508 94.2651Z",
    fill: "#48FFBD"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M52.2912 86.218C47.2159 83.9196 43.2376 86.5838 43.2212 92.5835C43.2165 92.4743 43.1858 92.3679 43.1317 92.2729C43.0776 92.178 43.0016 92.0973 42.9102 92.0376L42.5991 91.8574C42.7738 85.7267 46.9649 83.0516 52.2639 85.4755C52.2415 85.5648 52.2305 85.6565 52.2311 85.7485C52.2326 85.9068 52.2528 86.0644 52.2912 86.218Z",
    fill: "#48FFBD"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M29.5728 83.3847C29.9033 83.601 30.1784 83.8921 30.3756 84.2345C30.5728 84.5769 30.6866 84.9609 30.7079 85.3555C30.7079 86.0762 30.1622 86.3655 29.5619 86.0052C29.2314 85.7901 28.9564 85.4999 28.7591 85.1584C28.5619 84.8169 28.448 84.4337 28.4268 84.0398C28.4322 83.3137 28.9452 83.0244 29.5728 83.3847ZM29.5728 85.2791C29.8511 85.4429 30.0803 85.3118 30.0803 84.9897C30.0732 84.8131 30.0232 84.6408 29.9348 84.4877C29.8464 84.3346 29.7222 84.2053 29.5728 84.1108C29.2944 83.9525 29.0652 84.0781 29.0652 84.4002C29.0724 84.5768 29.1223 84.7491 29.2107 84.9022C29.2991 85.0553 29.4233 85.1846 29.5728 85.2791Z",
    fill: "#48FFBD"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M37.322 82.0963L37.3111 85.6667L29.4473 81.1246L29.4582 77.5542L37.322 82.0963Z",
    fill: "#48FFBD"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M62.3433 119.252L62.3378 122.822L54.4685 118.275L54.4794 114.704L62.3433 119.252Z",
    fill: "#48FFBD"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M53.2681 113.957V114.563L52.2858 114.017L52.1603 114.563C52.1949 114.567 52.2283 114.578 52.2585 114.595C52.2926 114.607 52.3255 114.621 52.3567 114.639C52.6434 114.811 52.8775 115.058 53.0335 115.354C53.2069 115.651 53.2991 115.988 53.3009 116.331C53.318 116.461 53.299 116.593 53.246 116.712C53.1931 116.832 53.1082 116.934 53.0007 117.008C52.8846 117.064 52.7551 117.087 52.6269 117.073C52.4987 117.06 52.3768 117.011 52.2749 116.932C52.0073 116.779 51.7807 116.564 51.6146 116.304C51.432 116.033 51.3092 115.726 51.2544 115.403L51.8547 115.753C51.8931 115.879 51.9541 115.997 52.0348 116.102C52.1015 116.195 52.187 116.273 52.2858 116.331C52.3342 116.361 52.3899 116.377 52.4468 116.377C52.5037 116.377 52.5594 116.361 52.6078 116.331C52.6577 116.294 52.6967 116.244 52.7207 116.186C52.7447 116.129 52.7528 116.066 52.7442 116.004C52.7426 115.841 52.6994 115.681 52.6187 115.54C52.5515 115.405 52.4474 115.291 52.3186 115.212C52.264 115.179 52.2021 115.161 52.1385 115.158C52.0748 115.164 52.0134 115.185 51.9584 115.218L51.4891 114.83L51.8602 113.121L53.2681 113.957Z",
    fill: "#48FFBD"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M53.3991 85.0881C53.6917 85.2794 53.9426 85.528 54.1368 85.8188C54.3309 86.1096 54.4642 86.4368 54.5287 86.7805C54.5454 86.8834 54.5546 86.9874 54.556 87.0916C54.5591 87.2274 54.5369 87.3626 54.4905 87.4902C54.3322 87.9214 53.9011 88.0361 53.3991 87.7577C52.8563 87.3983 52.4672 86.8493 52.3076 86.2181C52.2692 86.0646 52.2491 85.907 52.2476 85.7487C52.247 85.6567 52.258 85.5649 52.2803 85.4757C52.3786 84.9461 52.8424 84.766 53.3991 85.0881Z",
    fill: "#48FFBD"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M63.8168 103.142C63.9081 103.193 63.994 103.253 64.0733 103.322C64.3389 103.549 64.5557 103.828 64.7105 104.141C64.8653 104.455 64.9548 104.796 64.9737 105.145C64.9737 105.779 64.5808 106.084 64.0678 105.921C63.9758 105.894 63.8878 105.855 63.8059 105.806C63.6717 105.726 63.5471 105.631 63.4348 105.522C62.9667 105.068 62.6862 104.454 62.6489 103.802C62.6489 103.218 62.9818 102.907 63.4402 102.994C63.5734 103.021 63.7008 103.071 63.8168 103.142Z",
    fill: "#48FFBD"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M63.0747 128.189L63.0693 129.09L58.4961 126.447V125.547L63.0747 128.189Z",
    fill: "#48FFBD"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M31.0679 73.5634L31.0624 74.4642L26.4893 71.8219L26.4947 70.9211L31.0679 73.5634Z",
    fill: "#48FFBD"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.61,
    d: "M57.301 124.859L57.2955 125.754L54.938 124.389L54.9434 123.494L57.301 124.859Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.36
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.36
  }, _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M83.0263 78.8044C83.3331 79.0025 83.5885 79.2706 83.7716 79.5866C83.9547 79.9026 84.0602 80.2576 84.0796 80.6223L83.9541 126.131C83.9541 126.797 83.4793 127.064 82.8953 126.731L36.1487 99.7298C35.8422 99.5313 35.587 99.2632 35.404 98.9473C35.2209 98.6313 35.1152 98.2765 35.0955 97.9118L35.2264 52.4089C35.2264 51.7429 35.7012 51.4699 36.2797 51.8084L83.0263 78.8044Z",
    fill: "#48FFBD"
  })))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.26
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M47.9309 91.3881V92.7966L46.8395 92.8511C46.7475 92.6085 46.6977 92.3518 46.6921 92.0923C46.7194 91.3116 47.2651 91.0005 47.9309 91.3881Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M47.9309 90.6674V91.388C47.2542 91.0004 46.7085 91.3115 46.703 92.0922C46.7085 92.3517 46.7584 92.6084 46.8504 92.8511L46.3046 92.8838C46.1594 92.5149 46.0818 92.1229 46.0754 91.7265C46.0754 90.5527 46.9104 90.0778 47.9309 90.6674Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.9254 94.205C47.4216 93.8873 47.0376 93.411 46.834 92.8511L47.9254 92.7966V91.3881C48.2798 91.6217 48.5749 91.9348 48.7871 92.3025C48.9993 92.6702 49.1228 93.0824 49.1479 93.5063C49.1479 94.2815 48.6021 94.5926 47.9254 94.205Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M47.931 90.6674C48.4157 90.9841 48.8289 91.3989 49.1437 91.885C49.4586 92.3711 49.6682 92.9177 49.7591 93.4898L49.4699 93.326C49.2953 93.2223 49.1534 93.326 49.1534 93.5062C49.159 93.6152 49.1901 93.7213 49.2441 93.8161C49.2981 93.9109 49.3736 93.9917 49.4644 94.0521L49.7537 94.2213C49.6009 95.1385 48.8369 95.4606 47.9255 94.9365C47.1688 94.4536 46.5932 93.7338 46.2883 92.8893L46.8341 92.8565C47.0377 93.4164 47.4216 93.8927 47.9255 94.2104C48.6022 94.598 49.1479 94.2869 49.1534 93.5116C49.1283 93.0878 49.0048 92.6756 48.7926 92.3079C48.5804 91.9402 48.2854 91.6271 47.931 91.3934V90.6674Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M47.9254 94.931C48.8367 95.4769 49.6008 95.133 49.7536 94.2159L53.3717 96.3068C53.2025 99.5059 50.8177 100.745 47.9145 99.0364C45.8516 97.8463 44.0617 95.4988 43.1394 93.0312L46.3046 92.8674C46.6021 93.7156 47.172 94.4412 47.9254 94.931Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M41.1748 88.8985C41.1748 84.613 44.2254 82.8933 47.9472 85.0279V86.5074C44.9348 84.7713 42.49 86.1689 42.49 89.6301C42.505 90.7941 42.7287 91.9461 43.1503 93.0312L42.0098 93.0912C41.4863 91.7539 41.2036 90.3344 41.1748 88.8985Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M49.759 93.4899C49.6678 92.9186 49.4586 92.3726 49.1448 91.8867C48.8309 91.4007 48.4194 90.9855 47.9363 90.6675V86.5239C50.8395 88.2054 53.208 92.1906 53.3662 95.5808L49.759 93.4899Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.68,
    d: "M47.9472 86.5075V90.6511C46.9267 90.0615 46.0918 90.5364 46.0863 91.7102C46.0927 92.1066 46.1703 92.4986 46.3155 92.8675L43.1503 93.0313C42.7287 91.9462 42.505 90.7942 42.49 89.6301C42.4845 86.1853 44.9348 84.7878 47.9472 86.5075Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M47.909 100.565C51.5271 102.656 54.4958 101.073 54.6759 97.0547L54.9925 97.2403C54.8124 101.455 51.7181 103.114 47.8981 100.925C45.224 99.3858 42.9047 96.3341 41.7041 93.124H41.9824C43.1394 96.1758 45.355 99.091 47.909 100.565Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M47.9473 84.6676V85.0279C44.2255 82.8824 41.1858 84.613 41.1749 88.8985C41.1966 90.339 41.4737 91.7641 41.9935 93.1076H41.7152C41.1696 91.6999 40.8795 90.2062 40.8584 88.6965C40.8693 84.2309 44.0509 82.4184 47.9473 84.6676Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.6,
    d: "M40.3672 88.4292C40.3672 83.6632 43.8053 81.7088 47.9528 84.1054V84.6513C44.0563 82.4021 40.8584 84.2146 40.8584 88.6967C40.8794 90.2063 41.1696 91.7001 41.7151 93.1077H41.2895C40.7074 91.6152 40.3951 90.031 40.3672 88.4292Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M54.6759 96.3342C54.5231 92.1196 51.5708 87.1244 47.9526 85.0335V84.6677C51.7727 86.8514 54.8451 92.1032 54.9979 96.5143L54.6759 96.3342Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M61.1047 100.046C61.1971 100.105 61.2741 100.186 61.3292 100.281C61.3843 100.376 61.4158 100.483 61.4212 100.592C61.4212 100.789 61.2793 100.871 61.1047 100.772L54.9926 97.2403L54.676 97.0547L53.3718 96.3068L49.7536 94.2159L49.4644 94.0466C49.3735 93.9862 49.2981 93.9054 49.2441 93.8106C49.19 93.7158 49.159 93.6097 49.1533 93.5007C49.1533 93.2987 49.2952 93.2168 49.4698 93.3205L49.7591 93.4843L53.3772 95.5752L54.676 96.3286L54.9926 96.5088L61.1047 100.046Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M64.5974 103.082L64.8703 103.24V103.846L64.6029 103.693V104.403L64.0571 104.081V103.371L62.7419 102.612V102.001L64.0462 100.532L64.592 100.86L64.5974 103.082ZM64.0517 102.76V101.602L63.3586 102.361L64.0462 102.76",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M56.7662 80.4695C56.8583 80.5289 56.9351 80.6094 56.9901 80.7043C57.0451 80.7992 57.0769 80.9059 57.0827 81.0154C57.0827 81.212 56.9408 81.2938 56.7662 81.1956L56.4551 81.0154L45.5406 74.7154C45.4488 74.6557 45.3722 74.5751 45.3173 74.4802C45.2623 74.3854 45.2304 74.279 45.2241 74.1695C45.2241 73.9675 45.366 73.8856 45.5406 73.9894L56.4551 80.2893L56.7662 80.4695Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M70.8021 86.0161V87.0534L69.1649 86.1035L68.9521 87.037C69.01 87.0476 69.0667 87.0641 69.1212 87.0862L69.2795 87.1681C69.7591 87.454 70.1516 87.8655 70.4146 88.3582C70.7051 88.8555 70.8612 89.42 70.8676 89.996C70.8946 90.2136 70.8617 90.4344 70.7722 90.6346C70.6827 90.8347 70.5402 91.0066 70.3601 91.1315C70.1643 91.2244 69.9468 91.2619 69.7313 91.2397C69.5158 91.2176 69.3104 91.1367 69.1376 91.0059C68.6971 90.7417 68.3236 90.3792 68.0462 89.9468C67.7385 89.4959 67.5319 88.9838 67.4404 88.4455L68.45 89.0242C68.5189 89.2351 68.6202 89.434 68.7502 89.6138C68.8635 89.7678 69.0064 89.8977 69.1704 89.996C69.2489 90.0516 69.3408 90.0854 69.4366 90.094C69.5325 90.1026 69.6289 90.0858 69.7161 90.0451C69.7972 89.981 69.8604 89.8971 69.8996 89.8015C69.9388 89.7059 69.9527 89.6017 69.9398 89.4992C69.9369 89.2257 69.8657 88.9573 69.7325 88.7185C69.6187 88.4936 69.4449 88.3047 69.2304 88.1726C69.1381 88.1168 69.0326 88.0866 68.9248 88.0852C68.8159 88.0893 68.7101 88.1233 68.6192 88.1835L67.8388 87.5338L68.4609 84.6677L70.8021 86.0161Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M77.6673 94.2378C77.749 94.2841 77.8349 94.3224 77.9238 94.3525C77.3399 100.243 72.7395 102.454 67.184 99.2658C61.3502 95.8975 56.6024 87.8014 56.4551 81.0374L56.7661 81.2175C56.9408 81.3158 57.0827 81.2175 57.0827 81.0374C57.0827 87.4574 61.5958 95.3133 67.184 98.5397C72.4011 101.553 76.7287 99.4842 77.2908 93.9703C77.4058 94.0735 77.5321 94.1632 77.6673 94.2378Z",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M67.244 77.1339C71.9209 79.8362 75.6973 86.3819 75.6864 91.7592C75.6755 97.1366 71.8663 99.2985 67.1895 96.5961C62.5126 93.8938 58.7253 87.3536 58.7526 81.9763C58.7799 76.5989 62.5726 74.4316 67.244 77.1339ZM66.5182 88.9423C66.6926 88.8375 66.8326 88.684 66.9208 88.5007C67.009 88.3173 67.0417 88.1122 67.0148 87.9105C67.018 87.5319 66.932 87.1578 66.7638 86.8186C66.5901 86.4534 66.3473 86.1252 66.0489 85.8523C66.1498 85.8636 66.252 85.8507 66.3469 85.8146C66.4418 85.7786 66.5267 85.7204 66.5946 85.6449C66.7281 85.474 66.7958 85.2609 66.7856 85.0444C66.7584 84.5927 66.6136 84.1561 66.3654 83.7778C66.1147 83.3443 65.7579 82.9818 65.3286 82.7242C65.1667 82.5971 64.9721 82.5183 64.7674 82.4971C64.5627 82.4758 64.3562 82.5129 64.1716 82.604C64.048 82.6973 63.9473 82.8176 63.8774 82.9557C63.8074 83.0939 63.7699 83.2462 63.7678 83.4011L64.6901 83.947C64.7037 83.891 64.7322 83.8396 64.7725 83.7983C64.8129 83.757 64.8635 83.7273 64.9193 83.7123C64.9835 83.697 65.0502 83.6954 65.1151 83.7076C65.18 83.7198 65.2416 83.7456 65.2958 83.7833C65.4499 83.8743 65.5792 84.0017 65.6724 84.1545C65.7609 84.2975 65.8098 84.4614 65.8142 84.6294C65.8195 84.7349 65.7844 84.8384 65.716 84.9188C65.6833 84.9549 65.6425 84.9826 65.5969 84.9997C65.5514 85.0168 65.5024 85.0227 65.4541 85.0171C65.2721 84.9942 65.0961 84.9367 64.9356 84.8478V85.7868C65.2762 85.9793 65.5691 86.2462 65.7924 86.5675C65.9712 86.8105 66.0738 87.1013 66.0871 87.4028C66.0995 87.4953 66.0856 87.5894 66.047 87.6744C66.0084 87.7593 65.9466 87.8317 65.8688 87.8832C65.7797 87.9208 65.6823 87.934 65.5864 87.9215C65.4905 87.9091 65.3996 87.8713 65.3231 87.8122C65.0969 87.6807 64.9088 87.4926 64.7774 87.2663C64.6279 87.0149 64.5365 86.7332 64.51 86.4419L63.5604 85.896C63.5862 86.4894 63.7587 87.0671 64.0625 87.5775C64.3479 88.0731 64.7581 88.4853 65.2522 88.773C65.4319 88.9115 65.6438 89.0022 65.8681 89.0366C66.0923 89.0709 66.3217 89.0479 66.5346 88.9696L66.5182 88.9423ZM70.3547 91.1533C70.5348 91.0284 70.6774 90.8565 70.7668 90.6564C70.8563 90.4562 70.8893 90.2353 70.8622 90.0177C70.8558 89.4417 70.6997 88.8773 70.4092 88.38C70.1462 87.8873 69.7537 87.4758 69.2741 87.1898L69.0941 87.0534C69.0395 87.0312 68.9828 87.0148 68.9249 87.0042L69.1377 86.0707L70.7749 87.0206V86.0161L68.4174 84.6513L67.7952 87.5174L68.5756 88.167C68.6665 88.1069 68.7723 88.0729 68.8812 88.0688C68.989 88.0702 69.0946 88.1003 69.1868 88.1561C69.4014 88.2883 69.5751 88.4772 69.6889 88.7021C69.8221 88.9409 69.8934 89.2093 69.8963 89.4827C69.9091 89.5853 69.8952 89.6894 69.856 89.7851C69.8168 89.8807 69.7536 89.9646 69.6725 90.0287C69.5853 90.0693 69.4889 90.0862 69.393 90.0776C69.2972 90.0689 69.2053 90.0351 69.1268 89.9795C68.9628 89.8813 68.8199 89.7514 68.7066 89.5974C68.5766 89.4176 68.4753 89.2187 68.4064 89.0078L67.3969 88.4291C67.4883 88.9674 67.6949 89.4795 68.0026 89.9304C68.28 90.3628 68.6536 90.7253 69.0941 90.9895C69.2668 91.1203 69.4722 91.2012 69.6877 91.2233C69.9032 91.2454 70.1207 91.208 70.3165 91.1151",
    fill: "#48FFBD"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M77.2799 91.4208C76.7887 85.705 73.045 79.2248 68.3354 75.9165C68.3769 75.7878 68.3972 75.6532 68.3955 75.518C68.3972 75.4136 68.3881 75.3093 68.3682 75.2068C73.4052 78.7226 77.3999 85.6503 77.9129 91.7483C77.8324 91.6799 77.7466 91.6178 77.6564 91.5627C77.5402 91.4936 77.4128 91.4455 77.2799 91.4208Z",
    fill: "#48FFBD"
  }))), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M65.3121 82.686C65.7522 82.952 66.1153 83.3284 66.3653 83.7779C66.6217 84.1704 66.7669 84.625 66.7855 85.0935C66.7957 85.3101 66.728 85.5232 66.5946 85.6941C66.5266 85.7696 66.4417 85.8278 66.3468 85.8638C66.2519 85.8999 66.1497 85.9128 66.0488 85.9015C66.3472 86.1744 66.59 86.5026 66.7637 86.8678C66.9319 87.207 67.0179 87.581 67.0148 87.9596C67.0416 88.1613 67.0089 88.3665 66.9207 88.5498C66.8325 88.7332 66.6925 88.8867 66.5181 88.9914C66.3052 89.0698 66.0759 89.0928 65.8516 89.0585C65.6273 89.0241 65.4154 88.9334 65.2357 88.7949C64.7416 88.5071 64.3314 88.0949 64.046 87.5993C63.7423 87.089 63.5698 86.5113 63.5439 85.9179L64.4935 86.4638C64.52 86.7551 64.6114 87.0368 64.7609 87.2882C64.8923 87.5145 65.0804 87.7026 65.3066 87.8341C65.3832 87.8932 65.474 87.9309 65.5699 87.9434C65.6658 87.9559 65.7633 87.9427 65.8524 87.9051C65.9302 87.8536 65.9919 87.7812 66.0305 87.6962C66.0691 87.6113 66.083 87.5171 66.0706 87.4246C66.0573 87.1232 65.9547 86.8325 65.776 86.5894C65.5526 86.2681 65.2598 86.0012 64.9192 85.8087V84.8697C65.0796 84.9586 65.2556 85.0161 65.4376 85.0389C65.4859 85.0446 65.5349 85.0386 65.5805 85.0216C65.626 85.0045 65.6669 84.9767 65.6996 84.9407C65.7679 84.8603 65.803 84.7568 65.7978 84.6513C65.7933 84.4832 65.7444 84.3193 65.6559 84.1764C65.5627 84.0236 65.4334 83.8962 65.2794 83.8051C65.2251 83.7675 65.1635 83.7417 65.0986 83.7295C65.0338 83.7172 64.967 83.7188 64.9028 83.7342C64.8471 83.7492 64.7964 83.7789 64.7561 83.8202C64.7158 83.8615 64.6873 83.9128 64.6736 83.9689L63.7513 83.423C63.7534 83.2681 63.7909 83.1158 63.8609 82.9777C63.9309 82.8395 64.0315 82.7192 64.1552 82.626C64.3342 82.5263 64.5376 82.4791 64.7422 82.4897C64.9468 82.5004 65.1443 82.5684 65.3121 82.686Z",
    fill: "#48FFBD"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M66.1525 74.65C61.0773 72.3517 57.0989 75.0158 57.0826 81.0155C57.0767 80.906 57.045 80.7993 56.99 80.7044C56.935 80.6095 56.8582 80.529 56.7661 80.4696L56.4604 80.2894C56.6351 74.1587 60.8262 71.4836 66.1197 73.9021C66.102 73.9938 66.0929 74.0871 66.0925 74.1805C66.0912 74.339 66.1114 74.497 66.1525 74.65Z",
    fill: "#48FFBD"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M43.4449 71.8167C43.7767 72.0317 44.0526 72.3224 44.25 72.6651C44.4474 73.0078 44.5605 73.3925 44.58 73.7874C44.58 74.5026 44.067 74.7974 43.4394 74.4371C43.1093 74.2217 42.8345 73.9315 42.6373 73.59C42.44 73.2486 42.326 72.8655 42.3043 72.4717C42.288 71.7675 42.8009 71.4564 43.4449 71.8167ZM43.4449 73.711C43.7287 73.8693 43.9524 73.7438 43.9579 73.4217C43.9481 73.2456 43.897 73.0744 43.8089 72.9217C43.7207 72.769 43.5979 72.6392 43.4504 72.5427C43.1666 72.3789 42.9374 72.51 42.9374 72.8321C42.9476 73.008 42.9988 73.1791 43.0869 73.3318C43.1751 73.4844 43.2976 73.6142 43.4449 73.711Z",
    fill: "#48FFBD"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M51.178 70.5282L51.1671 74.0985L43.3032 69.5564L43.3141 65.9861L51.178 70.5282Z",
    fill: "#48FFBD"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M76.2047 107.678L76.1938 111.249L68.3245 106.707L68.3354 103.136L76.2047 107.678Z",
    fill: "#48FFBD"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M67.0967 102.383V102.994L66.1144 102.449L65.9944 102.994L66.0926 103.027C66.1252 103.04 66.1563 103.057 66.1854 103.076C66.4737 103.248 66.7096 103.495 66.8675 103.791C67.041 104.086 67.1333 104.421 67.1349 104.763C67.1501 104.894 67.1297 105.026 67.0759 105.146C67.0221 105.267 66.9369 105.37 66.8293 105.446C66.7129 105.5 66.5837 105.522 66.4557 105.509C66.3278 105.495 66.206 105.447 66.1035 105.369C65.8367 105.213 65.6104 104.996 65.4432 104.736C65.2596 104.467 65.1367 104.162 65.083 103.841L65.6833 104.185C65.7266 104.311 65.7872 104.43 65.8634 104.539C65.9346 104.628 66.0193 104.706 66.1144 104.769C66.1602 104.803 66.2146 104.824 66.2715 104.828C66.3284 104.833 66.3856 104.822 66.4364 104.796C66.4863 104.759 66.5253 104.708 66.5493 104.651C66.5733 104.593 66.5814 104.53 66.5728 104.468C66.5731 104.306 66.5318 104.146 66.4528 104.004C66.3855 103.869 66.2815 103.756 66.1526 103.677C66.0959 103.644 66.0323 103.626 65.9671 103.622C65.9025 103.625 65.8401 103.646 65.787 103.682L65.3231 103.295L65.6942 101.586L67.0967 102.383Z",
    fill: "#48FFBD"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M67.255 73.5145C67.548 73.7066 67.7991 73.9561 67.9932 74.2479C68.1874 74.5397 68.3205 74.8677 68.3846 75.2123C68.4045 75.3148 68.4136 75.4191 68.4119 75.5235C68.4136 75.6587 68.3933 75.7933 68.3519 75.922C68.1936 76.3533 67.757 76.4679 67.2604 76.1895C66.7147 75.8333 66.3246 75.283 66.169 74.65C66.1279 74.4969 66.1077 74.339 66.1089 74.1805C66.1094 74.087 66.1185 73.9938 66.1362 73.9021C66.2399 73.4053 66.7038 73.1978 67.255 73.5145Z",
    fill: "#48FFBD"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M77.6727 91.5682C77.7629 91.6233 77.8487 91.6853 77.9292 91.7538C78.1959 91.98 78.4133 92.2586 78.5682 92.5722C78.723 92.8858 78.812 93.2278 78.8297 93.5772C78.8297 94.2104 78.4422 94.5161 77.9238 94.3524C77.8349 94.3223 77.749 94.2839 77.6673 94.2377C77.5309 94.1562 77.4046 94.0592 77.2907 93.9484C76.8239 93.4953 76.5435 92.8837 76.5049 92.2342C76.5049 91.6446 76.8432 91.3389 77.2962 91.4262C77.4291 91.4509 77.5566 91.499 77.6727 91.5682Z",
    fill: "#48FFBD"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M76.9307 116.621V117.516L72.3521 114.879L72.3575 113.978L76.9307 116.621Z",
    fill: "#48FFBD"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M44.924 61.9953V62.8906L40.3508 60.2483V59.353L44.924 61.9953Z",
    fill: "#48FFBD"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    d: "M71.1568 113.285V114.186L68.7993 112.821V111.926L71.1568 113.285Z",
    fill: "#48FFBD"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M95.6872 19.5168L97.7282 20.6961L97.6682 40.6005L95.6272 39.4213L95.6872 19.5168ZM97.3244 39.9072L97.3571 28.3499L95.9983 27.5693L95.9655 39.1265L97.3244 39.9072Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M97.3625 28.3498L97.3297 39.907L95.9763 39.1263L96.0091 27.5691L97.3625 28.3498Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M100.304 35.8398L100.288 41.5994L98.9287 40.8187L98.9505 35.0537L100.304 35.8398Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M98.645 21.2256L100.686 22.4048L100.631 42.3092L98.585 41.1301L98.645 21.2256ZM100.282 41.5996V35.84L98.9233 35.0539V40.8189L100.282 41.5996Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M101.603 22.9343L103.644 24.1135L103.589 44.018L101.543 42.8388L101.603 22.9343ZM103.24 43.3083L103.284 26.9305L101.93 26.1498L101.881 42.5276L103.24 43.3083Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M103.295 26.9196L103.245 43.3083L101.892 42.5276L101.936 26.1389L103.295 26.9196Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M106.231 36.1838L106.209 45.0388L104.85 44.2526L104.877 35.3977L106.231 36.1838Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M104.566 24.6431L106.607 25.8223L106.552 45.7267L104.511 44.5475L104.566 24.6431ZM106.203 45.0389L106.231 36.184L104.877 35.3978L104.85 44.2527L106.203 45.017",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M109.172 44.8151L109.166 46.7477L107.808 45.9615L107.813 44.0344L109.172 44.8151Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M107.518 26.3518L109.559 27.531L109.505 47.4355L107.464 46.2563L107.518 26.3518ZM109.156 46.7476V44.815L107.84 44.0344V45.9615L109.194 46.7476",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M93.6626 18.3485V19.0964L91.7417 17.9882V17.2402L93.6626 18.3485Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M93.6517 23.1363L93.6463 23.8842L91.7253 22.776L91.7308 22.0281L93.6517 23.1363Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M93.6353 27.9295V28.6774L91.7144 27.5692V26.8213L93.6353 27.9295Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M93.6244 32.7117L93.6189 33.4651L91.698 32.3569L91.7035 31.6035L93.6244 32.7117Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M93.608 37.505V38.2529L91.687 37.1446V36.3967L93.608 37.505Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M112.992 29.5073L112.987 30.2607L111.071 29.1525V28.4045L112.992 29.5073Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M112.976 34.3004V35.0483L111.06 33.9401V33.1921L112.976 34.3004Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M112.965 39.0881L112.959 39.836L111.044 38.7333L111.049 37.9854L112.965 39.0881Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M112.948 43.8761V44.6294L111.033 43.5212V42.7678L112.948 43.8761Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M112.938 48.6638L112.932 49.4172L111.017 48.309L111.022 47.561L112.938 48.6638Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M65.1102 4.13269C65.2361 4.21442 65.3407 4.32483 65.4157 4.45483C65.4906 4.58483 65.5337 4.73073 65.5414 4.8806V8.82767C65.5414 9.10609 65.3449 9.21526 65.1048 9.07877C64.9782 8.99614 64.8727 8.88495 64.7968 8.7541C64.721 8.62325 64.677 8.47639 64.6682 8.32539V4.37836C64.6737 4.1054 64.8701 3.99075 65.1102 4.13269Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M65.1156 2.02538C65.3189 2.1585 65.488 2.33753 65.6093 2.54805C65.7307 2.75857 65.8008 2.99468 65.8142 3.23732L65.7596 21.171C65.7596 21.6132 65.4431 21.7934 65.0611 21.5695C64.8566 21.4377 64.6866 21.259 64.5651 21.0482C64.4436 20.8374 64.3742 20.6006 64.3625 20.3576L64.4117 2.42936C64.4117 1.9817 64.7282 1.80701 65.1156 2.02538ZM65.5304 8.82763V4.88057C65.5227 4.73069 65.4796 4.5848 65.4047 4.45479C65.3297 4.32479 65.2251 4.21439 65.0993 4.13265C64.8592 3.99071 64.6627 4.10536 64.6627 4.37832V8.32536C64.6715 8.47635 64.7155 8.62321 64.7913 8.75406C64.8672 8.88491 64.9726 8.9961 65.0993 9.07874C65.3394 9.21522 65.5359 9.10606 65.5359 8.82763",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M65.1157 1.51761C65.4229 1.71657 65.6785 1.98558 65.8616 2.30255C66.0447 2.61952 66.15 2.97539 66.169 3.34099L66.1144 21.4767C66.1144 22.1482 65.6396 22.4157 65.0557 22.0826C64.7503 21.8818 64.4961 21.6123 64.3132 21.2957C64.1303 20.9792 64.0239 20.6243 64.0024 20.2593L64.057 2.11812C64.057 1.45209 64.5318 1.17914 65.1157 1.51761ZM65.7597 21.1709L65.8142 3.23726C65.8009 2.99462 65.7307 2.75851 65.6094 2.54799C65.488 2.33746 65.3189 2.15844 65.1157 2.02532C64.7282 1.80695 64.4117 1.98164 64.4117 2.4293L64.3626 20.3575C64.3742 20.6006 64.4437 20.8373 64.5652 21.0481C64.6866 21.2589 64.8567 21.4377 65.0611 21.5695C65.4431 21.7933 65.7597 21.6131 65.7597 21.1709Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M68.1556 9.34607C68.2814 9.4278 68.386 9.53821 68.461 9.66821C68.5359 9.79821 68.579 9.94414 68.5867 10.094V14.041C68.5867 14.3195 68.3902 14.4286 68.1501 14.2922C68.0239 14.2096 67.919 14.0983 67.8441 13.9673C67.7691 13.8364 67.7263 13.6895 67.719 13.5388V9.59174C67.719 9.31878 67.9154 9.20412 68.1556 9.34607Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M68.1718 3.79403C68.374 3.92692 68.5425 4.10519 68.6637 4.31463C68.785 4.52408 68.8557 4.75894 68.8703 5.00054L68.8158 22.9342C68.8158 23.3764 68.4992 23.5566 68.1118 23.3327C67.9094 23.2005 67.7411 23.0223 67.6206 22.8126C67.5002 22.6029 67.431 22.3677 67.4187 22.1262L67.4678 4.19254C67.4569 3.75034 67.7843 3.5702 68.1718 3.79403ZM68.5756 14.0411V10.094C68.5679 9.94417 68.5249 9.79823 68.4499 9.66823C68.375 9.53823 68.2703 9.42782 68.1445 9.34609C67.9044 9.20415 67.7079 9.34609 67.7079 9.59176V13.5388C67.7152 13.6895 67.7581 13.8364 67.833 13.9673C67.908 14.0983 68.0128 14.2096 68.1391 14.2922C68.3792 14.4287 68.5756 14.2922 68.5756 14.0411Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M68.1719 3.28103C68.4791 3.47999 68.7347 3.749 68.9178 4.06597C69.1009 4.38294 69.2062 4.73885 69.2251 5.10444L69.1706 23.2401C69.1706 23.9116 68.6958 24.1845 68.1119 23.8461C67.8056 23.6461 67.5506 23.3769 67.3677 23.0602C67.1847 22.7434 67.0788 22.388 67.0586 22.0227L67.1132 3.88157C67.1132 3.21554 67.5879 2.94256 68.1719 3.28103ZM68.8158 22.9344L68.8704 5.00071C68.8558 4.75912 68.785 4.52425 68.6638 4.31481C68.5425 4.10536 68.3741 3.9271 68.1719 3.79421C67.7844 3.57038 67.4679 3.75052 67.4679 4.19272L67.4188 22.1264C67.4311 22.3679 67.5003 22.6031 67.6207 22.8128C67.7412 23.0225 67.9094 23.2007 68.1119 23.3329C68.4993 23.5567 68.8158 23.3766 68.8158 22.9344Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M71.206 13.2441C71.3328 13.3261 71.4382 13.4373 71.5132 13.5684C71.5882 13.6994 71.6307 13.8466 71.6371 13.9975V17.9391C71.6371 18.2176 71.4406 18.3267 71.2005 18.1902C71.0736 18.1079 70.9679 17.9968 70.892 17.8659C70.8161 17.7349 70.7722 17.5879 70.7639 17.4369V13.4953C70.7694 13.2114 70.9658 13.1022 71.206 13.2441Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M71.2278 5.04438C71.5341 5.24431 71.789 5.51351 71.972 5.83028C72.1549 6.14704 72.2608 6.50246 72.281 6.86775L72.2264 25.0089C72.2264 25.6749 71.7517 25.9479 71.1677 25.6094C70.8615 25.4095 70.6065 25.1402 70.4236 24.8235C70.2406 24.5067 70.1347 24.1513 70.1145 23.786L70.1691 5.65035C70.1854 4.97886 70.6439 4.71136 71.2278 5.04438ZM71.8717 24.6977L71.9208 6.76949C71.9094 6.52703 71.8406 6.29074 71.7201 6.08005C71.5997 5.86936 71.4309 5.69027 71.2278 5.55751C70.8403 5.33369 70.5238 5.51386 70.5238 5.95606L70.4747 23.8897C70.4865 24.1313 70.5555 24.3667 70.676 24.5765C70.7965 24.7862 70.965 24.9643 71.1677 25.0962C71.5552 25.3201 71.8717 25.1454 71.8717 24.6977Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M71.228 5.55745C71.4311 5.69021 71.5998 5.8693 71.7203 6.07998C71.8408 6.29067 71.9096 6.52696 71.921 6.76942L71.8719 24.6977C71.8719 25.1453 71.5554 25.32 71.1679 25.0962C70.9652 24.9643 70.7967 24.7861 70.6762 24.5764C70.5557 24.3667 70.4867 24.1313 70.4749 23.8897L70.524 5.956C70.524 5.5138 70.8405 5.33362 71.228 5.55745ZM71.6263 17.9391V13.9975C71.6199 13.8466 71.5774 13.6994 71.5024 13.5683C71.4274 13.4372 71.3221 13.326 71.1952 13.2441C70.9551 13.1022 70.7586 13.2114 70.7586 13.4952V17.4368C70.7669 17.5879 70.8108 17.7349 70.8867 17.8658C70.9626 17.9967 71.0683 18.1079 71.1952 18.1902C71.4353 18.3267 71.6318 18.1902 71.6318 17.9391",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M74.2838 6.80224C74.5901 7.00217 74.845 7.27141 75.028 7.58818C75.211 7.90494 75.3169 8.26036 75.3371 8.62565L75.2825 26.7668C75.2825 27.4382 74.8077 27.7112 74.2238 27.3727C73.9179 27.1728 73.6636 26.9035 73.4815 26.5866C73.2994 26.2698 73.1948 25.9144 73.176 25.5494L73.2251 7.40821C73.2306 6.74764 73.6999 6.47469 74.2838 6.80224ZM74.9278 26.4556L74.9769 8.52735C74.9655 8.2849 74.8967 8.04864 74.7762 7.83795C74.6557 7.62726 74.487 7.44817 74.2838 7.31541C73.8964 7.09158 73.5853 7.27719 73.5799 7.71939L73.5307 25.6531C73.543 25.8946 73.6122 26.1298 73.7327 26.3395C73.8531 26.5491 74.0214 26.7273 74.2238 26.8596C74.6113 27.0834 74.9278 26.9032 74.9278 26.4556Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M74.2676 12.1468C74.3955 12.2282 74.5019 12.3391 74.5779 12.4702C74.6539 12.6014 74.6972 12.7488 74.7042 12.9002V16.8418C74.7042 17.1203 74.5078 17.2294 74.2622 17.0929C74.1363 17.01 74.0316 16.8986 73.9567 16.7678C73.8818 16.6369 73.8388 16.4902 73.8311 16.3396V12.3925C73.8311 12.1196 74.0057 12.0049 74.2676 12.1468Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M74.2839 7.34808C74.487 7.48083 74.6557 7.65992 74.7762 7.87061C74.8967 8.0813 74.9655 8.31756 74.9769 8.56002L74.9278 26.4882C74.9278 26.9359 74.6113 27.1161 74.2238 26.8922C74.0214 26.76 73.8531 26.5818 73.7327 26.3721C73.6122 26.1624 73.543 25.9273 73.5308 25.6857L73.5799 7.75206C73.5853 7.28256 73.8964 7.09695 74.2839 7.34808ZM74.6932 16.869V12.9274C74.6862 12.776 74.6428 12.6285 74.5668 12.4974C74.4908 12.3663 74.3844 12.2554 74.2566 12.1741C74.0164 12.0321 73.82 12.1741 73.82 12.4197V16.3668C73.8277 16.5174 73.8708 16.6641 73.9456 16.795C74.0205 16.9258 74.1252 17.0372 74.2511 17.1202C74.4967 17.2566 74.6932 17.1202 74.6932 16.869Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M77.3128 16.771C77.4403 16.8526 77.5465 16.9636 77.6225 17.0947C77.6984 17.2257 77.7419 17.3731 77.7494 17.5244V21.4714C77.7494 21.7444 77.5529 21.859 77.3128 21.7225C77.1868 21.6393 77.0817 21.5279 77.006 21.3972C76.9302 21.2664 76.8858 21.1199 76.8762 20.9692V17.0221C76.8817 16.7437 77.0727 16.629 77.3128 16.771Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.52,
    d: "M77.34 9.08968C77.5438 9.22215 77.7134 9.40106 77.8348 9.61172C77.9562 9.82238 78.0261 10.0588 78.0385 10.3016L77.9894 28.2298C77.9894 28.672 77.6729 28.8522 77.2854 28.6284C77.082 28.4968 76.9127 28.3188 76.7912 28.1091C76.6698 27.8994 76.5998 27.6639 76.5869 27.4219L76.636 9.4882C76.6415 9.046 76.9525 8.86585 77.34 9.08968ZM77.7384 21.4713V17.5242C77.7296 17.3733 77.6856 17.2264 77.6097 17.0956C77.5339 16.9647 77.4284 16.8535 77.3018 16.7709C77.0617 16.6344 76.8707 16.7708 76.8652 17.022V20.969C76.8748 21.1198 76.9192 21.2663 76.995 21.397C77.0707 21.5278 77.1758 21.6392 77.3018 21.7224C77.5419 21.8589 77.7384 21.7224 77.7384 21.4713Z",
    fill: "#31E2FF"
  })), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M77.34 8.57631C77.6466 8.77592 77.9017 9.04508 78.0848 9.36192C78.2678 9.67875 78.3735 10.0343 78.3933 10.3997L78.3387 28.5354C78.3387 29.2069 77.8639 29.4798 77.2854 29.1413C76.9773 28.9434 76.721 28.6746 76.5378 28.3574C76.3546 28.0403 76.2498 27.6839 76.2322 27.318L76.2813 9.18228C76.2868 8.51079 76.7342 8.23784 77.34 8.57631ZM77.9894 28.2296L78.0385 10.3014C78.0261 10.0586 77.9562 9.82218 77.8348 9.61152C77.7134 9.40086 77.5438 9.22196 77.34 9.08949C76.9525 8.86566 76.6415 9.0458 76.636 9.488L76.5869 27.4217C76.5975 27.6651 76.6659 27.9025 76.7864 28.1142C76.9069 28.3259 77.0761 28.5058 77.28 28.6391C77.6674 28.8629 77.9785 28.6828 77.984 28.2406",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M61.6722 0.846121C61.7583 0.901007 61.83 0.975729 61.8813 1.06407C61.9326 1.15241 61.962 1.25179 61.9669 1.35383C61.9669 1.53944 61.8359 1.61587 61.6722 1.5176L60.2752 0.71507C60.1893 0.659851 60.1179 0.585025 60.0666 0.496753C60.0154 0.408481 59.9859 0.309294 59.9805 0.207363C59.9805 0.0162892 60.1169 -0.0546745 60.2806 0.0435922L61.6722 0.846121Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M61.6612 5.16439C61.7457 5.22054 61.8159 5.2957 61.8661 5.38387C61.9164 5.47204 61.9452 5.57075 61.9505 5.67209C61.9505 5.85771 61.8249 5.9396 61.6612 5.84133L60.2642 5.03883C60.1782 4.98243 60.1068 4.90657 60.0556 4.81742C60.0044 4.72827 59.9749 4.62833 59.9695 4.52566C59.9695 4.34005 60.1005 4.26363 60.2642 4.36189L61.6612 5.16439Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M61.6502 9.47183C61.7347 9.52798 61.8049 9.60315 61.8551 9.69131C61.9054 9.77948 61.9343 9.87819 61.9395 9.97954C61.9395 10.1652 61.8085 10.247 61.6448 10.1488L60.2532 9.34625C60.1669 9.29017 60.0953 9.21441 60.044 9.1252C59.9928 9.03598 59.9635 8.93584 59.9585 8.83307C59.9585 8.64746 60.0895 8.57649 60.2532 8.6693L61.6502 9.47183Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M61.634 13.7901C61.7202 13.845 61.7919 13.9197 61.8432 14.0081C61.8944 14.0964 61.9238 14.1958 61.9287 14.2978C61.9287 14.4834 61.7978 14.5598 61.634 14.467L60.2424 13.6591C60.156 13.6045 60.0841 13.5299 60.0327 13.4415C59.9814 13.353 59.9523 13.2535 59.9478 13.1514C59.9478 12.9658 60.0787 12.8893 60.2424 12.9821L61.634 13.7901Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M61.6231 18.1029C61.7093 18.1578 61.781 18.2325 61.8323 18.3209C61.8835 18.4092 61.9129 18.5085 61.9178 18.6106C61.9178 18.7962 61.7869 18.8726 61.6231 18.7798L60.2261 17.9718C60.1403 17.9166 60.0688 17.8418 60.0176 17.7535C59.9663 17.6653 59.9368 17.5661 59.9314 17.4641C59.9314 17.2785 60.0678 17.2021 60.2316 17.2949L61.6231 18.1029Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M81.6456 12.3814C81.7313 12.4354 81.8028 12.5093 81.8541 12.5967C81.9054 12.6841 81.9349 12.7825 81.9403 12.8837C81.9403 13.0748 81.8039 13.1457 81.6456 13.0529L80.2486 12.2449C80.1628 12.1909 80.0914 12.1171 80.0401 12.0297C79.9888 11.9423 79.9592 11.8439 79.9539 11.7427C79.9539 11.5516 80.0903 11.4806 80.254 11.5735L81.6456 12.3814Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M81.6456 16.6944C81.7291 16.7503 81.7986 16.8247 81.8488 16.9118C81.8989 16.9989 81.9284 17.0963 81.9348 17.1966C81.9348 17.3877 81.8039 17.4641 81.6456 17.3713L80.2486 16.5634C80.1627 16.5082 80.0913 16.4333 80.04 16.3451C79.9888 16.2568 79.9593 16.1576 79.9539 16.0557C79.9539 15.8701 80.0903 15.7936 80.254 15.8864L81.6456 16.6944Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M81.6456 20.9962C81.7298 21.0526 81.7998 21.1279 81.8499 21.216C81.9001 21.3041 81.9292 21.4026 81.9348 21.5039C81.9348 21.6895 81.8039 21.7659 81.6401 21.6731L80.2486 20.8651C80.1627 20.8099 80.0913 20.7351 80.04 20.6468C79.9888 20.5585 79.9593 20.4594 79.9539 20.3574C79.9539 20.1718 80.0848 20.0954 80.2486 20.1882L81.6456 20.9962Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M81.6021 25.32C81.6879 25.3752 81.7593 25.45 81.8106 25.5383C81.8618 25.6266 81.8914 25.7258 81.8967 25.8277C81.9035 25.8644 81.8988 25.9023 81.8831 25.9362C81.8675 25.97 81.8417 25.9982 81.8093 26.0168C81.777 26.0353 81.7397 26.0434 81.7025 26.0399C81.6654 26.0363 81.6303 26.0213 81.6021 25.9969L80.2105 25.1945C80.1255 25.1383 80.0548 25.0632 80.0036 24.9751C79.9525 24.8871 79.9224 24.7884 79.9158 24.6867C79.9158 24.4957 80.0467 24.4192 80.2105 24.5175L81.6021 25.32Z",
    fill: "#31E2FF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.57,
    d: "M81.5912 29.6328C81.6774 29.6889 81.7491 29.7646 81.8003 29.8538C81.8516 29.943 81.8809 30.0432 81.8859 30.146C81.8859 30.3261 81.7494 30.4025 81.5912 30.3097L80.1941 29.5072C80.1089 29.4514 80.0379 29.3764 79.9867 29.2882C79.9356 29.2001 79.9057 29.1012 79.8994 28.9995C79.8994 28.8084 80.0359 28.732 80.1996 28.8303L81.5912 29.6328Z",
    fill: "#31E2FF"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8438 56.8964L55.8492 57.879L56.7005 57.3822V56.405L55.8438 56.8964Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6497 62.9016L45.6551 63.7641L48.8913 61.8971V61.0291L45.6497 62.9016Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M53.6829 58.1465L53.6883 59.1291L55.0199 58.3539V57.3767L53.6829 58.1465Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M45.6279 60.8817C45.5558 60.929 45.496 60.9928 45.4533 61.0678C45.4106 61.1427 45.3863 61.2267 45.3823 61.3129C45.3823 61.4658 45.4915 61.5313 45.6279 61.4549L56.6788 55.073C56.7509 55.0256 56.8107 54.9619 56.8534 54.8869C56.8961 54.8119 56.9204 54.7279 56.9244 54.6417C56.9244 54.4834 56.8152 54.4234 56.6733 54.4998L45.6279 60.8817Z",
    fill: "#48FFBD"
  })))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "M52.0728 48.0088L52.0946 55.5862L52.875 55.1331L52.8531 47.5557L52.0728 48.0088Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M50.7468 51.6335L50.7632 56.3558L51.5436 55.9027L51.5272 51.1804L50.7468 51.6335Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M49.426 53.8064L49.4315 57.1202L50.2119 56.6725L50.201 53.3533L49.426 53.8064Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M48.0835 51.1804L48.0999 57.8898L48.8803 57.4422L48.8584 50.7273L48.0835 51.1804Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M46.7683 57.2566V58.6596L47.5542 58.212L47.5487 56.8035L46.7683 57.2566Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M54.7415 49.2698L54.7578 54.0466L55.5382 53.599L55.5273 48.8167L54.7415 49.2698Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M53.3989 45.1152L53.4262 54.8163L54.2066 54.3632L54.1793 44.6621L53.3989 45.1152Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M57.2407 40.3275V41.4303L58.2012 40.8789L58.1957 39.7761L57.2407 40.3275Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M45.4861 47.1189V47.6703L46.8449 46.8841V46.3328L45.4861 47.1189Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M41.4148 65.2326L41.4203 66.2098L42.2716 65.7185L42.2661 64.7358L41.4148 65.2326Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M39.2539 66.4773L39.2594 67.4599L40.5909 66.6902L40.5855 65.7075L39.2539 66.4773Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2207 71.2378V72.1003L34.4678 70.2278L34.4623 69.3652L31.2207 71.2378Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M31.2099 69.218C31.1386 69.2649 31.0792 69.3278 31.0365 69.4017C30.9939 69.4757 30.9692 69.5586 30.9644 69.6439C30.9644 69.8022 31.0735 69.8677 31.2154 69.7858L42.2608 63.4039C42.3332 63.3577 42.3937 63.295 42.4373 63.2211C42.4809 63.1471 42.5065 63.0638 42.5119 62.9781C42.5119 62.8198 42.3972 62.7543 42.2608 62.8362L31.2099 69.218Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M37.644 56.3395L37.6659 63.917L38.4463 63.4693L38.4244 55.8918L37.644 56.3395Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M36.3232 59.9645L36.3342 64.6868L37.1091 64.2391L37.0982 59.5168L36.3232 59.9645Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M34.9917 62.1374L35.0026 65.4566L35.783 65.0035L35.7775 61.6897L34.9917 62.1374Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M33.6548 59.5114L33.6712 66.2263L34.4515 65.7732L34.4352 59.0637L33.6548 59.5114Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M32.334 65.5876L32.3394 66.996L33.1198 66.5429V65.1399L32.334 65.5876Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M40.3125 57.6005L40.3234 62.3828L41.1093 61.9297L41.0929 57.1528L40.3125 57.6005Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M38.9646 53.4517L38.9919 63.1528L39.7777 62.6996L39.7504 52.9985L38.9646 53.4517Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8064 48.6637L42.8119 49.7665L43.7669 49.2096V48.1123L42.8064 48.6637Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M31.0571 55.4496V56.001L32.416 55.2149V54.6689L31.0571 55.4496Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M26.353 73.9293L26.3585 74.912L27.2098 74.4152L27.2044 73.438L26.353 73.9293Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M24.1919 75.1794V76.1621L25.5289 75.3869V74.4097L24.1919 75.1794Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1587 79.9345V80.7971L19.4003 78.93V78.062L16.1587 79.9345Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M16.1587 77.9146C16.0856 77.9614 16.0247 78.0249 15.9811 78.0999C15.9374 78.1749 15.9123 78.2592 15.9077 78.3459C15.9077 78.4988 16.0169 78.5643 16.1587 78.4878L27.2096 72.106C27.2817 72.0586 27.3416 71.9948 27.3843 71.9199C27.4269 71.8449 27.4513 71.7609 27.4552 71.6747C27.4552 71.5164 27.3406 71.4563 27.2042 71.5327L16.1587 77.9146Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M22.582 65.0415L22.5984 72.619L23.3842 72.1658L23.3624 64.5884L22.582 65.0415Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2559 68.6665L21.2722 73.3888L22.0526 72.9356L22.0362 68.2134L21.2559 68.6665Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M19.9297 70.8393L19.9351 74.1585L20.721 73.7054L20.7101 70.3916L19.9297 70.8393Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M18.5928 68.2135L18.6091 74.923L19.3895 74.4753L19.3677 67.7659L18.5928 68.2135Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M17.272 74.2895L17.2774 75.6925L18.0578 75.2448L18.0524 73.8418L17.272 74.2895Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2505 66.3027L25.2669 71.0796L26.0472 70.6319L26.0309 65.8496L25.2505 66.3027Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M23.9026 62.1482L23.9353 71.8493L24.7157 71.4016L24.6884 61.6951L23.9026 62.1482Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M27.7444 57.3605L27.7498 58.4632L28.7049 57.9119V56.8091L27.7444 57.3605Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M15.9897 64.1516L15.9952 64.703L17.3541 63.9169V63.3655L15.9897 64.1516Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9241 82.2655V83.2427L12.7809 82.7514L12.7754 81.7742L11.9241 82.2655Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M9.75757 83.5157L9.76303 84.4929L11.1 83.7231L11.0946 82.7405L9.75757 83.5157Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M1.72998 88.2707V89.1333L4.97158 87.2608L4.96612 86.3982L1.72998 88.2707Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M1.71897 86.2508C1.64688 86.2981 1.58704 86.3619 1.54435 86.4369C1.50166 86.5118 1.47734 86.5959 1.47339 86.682C1.47339 86.8349 1.58253 86.9004 1.72442 86.8185L12.7699 80.4421C12.842 80.3947 12.9018 80.3309 12.9445 80.256C12.9872 80.181 13.0115 80.097 13.0154 80.0108C13.0154 79.8525 12.9063 79.787 12.7699 79.8689L1.71897 86.2508Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M8.14771 73.3779L8.16953 80.9554L8.94992 80.5023L8.92809 72.9248L8.14771 73.3779Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M6.83228 76.9975L6.84319 81.7197L7.61812 81.2721L7.6072 76.5498L6.83228 76.9975Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M5.50073 79.1755L5.51165 82.4893L6.28657 82.0416L6.28112 78.7224L5.50073 79.1755Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M4.15845 76.5498L4.18028 83.2592L4.9552 82.8116L4.93883 76.0967L4.15845 76.5498Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M2.84326 82.626L2.84872 84.029L3.6291 83.5759L3.62365 82.1729L2.84326 82.626Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8215 74.6335L10.8324 79.4158L11.6128 78.9626L11.6019 74.1858L10.8215 74.6335Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M9.47363 70.4844L9.50092 80.1855L10.2813 79.7324L10.254 70.0312L9.47363 70.4844Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.81
  }, _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M13.3157 65.6966L13.3211 66.7994L14.2761 66.2426V65.1453L13.3157 65.6966Z",
    fill: "#48FFBD"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "screen"
    },
    opacity: 0.2
  }, _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M1.56079 72.488V73.034L2.9251 72.2478L2.91964 71.7019L1.56079 72.488Z",
    fill: "#48FFBD"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_1148_2557",
    x: 51.2004,
    y: 120.58,
    width: 135.442,
    height: 79.3672,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6,
    result: "effect1_foregroundBlur_1148_2557"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8437 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8437 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1628 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint7_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8437 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8437 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8437 142.738) scale(46.1627 46.18)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.18)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8437 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8437 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint21_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8434 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint24_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint25_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint26_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8437 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint28_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint29_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8437 142.738) scale(46.1627 46.18)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint30_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint31_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint32_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint33_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint35_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint37_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint39_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint41_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint43_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8437 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint45_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8437 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint47_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8437 142.738) scale(46.1627 46.18)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint49_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1573 46.1744)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint51_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint53_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.18)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8437 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint55_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint57_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint59_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1798)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint61_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8436 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint63_radial_1148_2557",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(84.8435 142.738) scale(46.1627 46.1799)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00B1FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#00B1FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_1148_2557",
    x1: 108.091,
    y1: 157.15,
    x2: 120.563,
    y2: 130.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F2F5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#DADDE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CDD0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B7BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_1148_2557",
    x1: 113.09,
    y1: 35.0429,
    x2: 189.74,
    y2: 160.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#313131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_1148_2557",
    x1: 169.136,
    y1: 140.39,
    x2: 167.547,
    y2: 151.025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F2F5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#DADDE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CDD0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B7BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_1148_2557",
    x1: 82.3769,
    y1: 156.162,
    x2: 146.63,
    y2: 156.162,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F2F5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#DADDE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CDD0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B7BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_1148_2557",
    x1: 46.4792,
    y1: 71.3797,
    x2: 209.64,
    y2: 206.628,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#F2F5F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.56,
    stopColor: "#DADDE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#CDD0D5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B5B7BB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_1148_2557",
    x1: 56.9843,
    y1: 12.2395,
    x2: 165.043,
    y2: 148.605,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.24,
    stopColor: "#666666"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.31,
    stopColor: "#5D5D5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#434343"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.81,
    stopColor: "#313131"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#313131"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_1148_2557",
    x1: 135.219,
    y1: 66.5647,
    x2: 216.851,
    y2: 22.8286,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#777777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15,
    stopColor: "#9F9F9F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#777777"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_1148_2557",
    x1: 149.381,
    y1: 153.569,
    x2: 74.4041,
    y2: 12.0879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6BA6F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#5D8ECD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2A3447"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_1148_2557",
    x1: 141.075,
    y1: -32.1386,
    x2: 67.3635,
    y2: 82.2407,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_1148_2557",
    x1: 168.885,
    y1: -14.2214,
    x2: 95.1682,
    y2: 100.163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#BCBCBC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#8A8A8A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#5F5F5F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.49,
    stopColor: "#3D3D3D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61,
    stopColor: "#222222"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#0F0F0F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.87,
    stopColor: "#040404"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_1148_2557",
    x1: 165.463,
    y1: 25.5492,
    x2: 148.835,
    y2: 80.455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#29ABE2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.18,
    stopColor: "#1F81AA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.39,
    stopColor: "#14536E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#0B2F3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.76,
    stopColor: "#05161C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "#010608"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1148_2557"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 181,
    height: 200,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.e051cd40cd0d60fde4e06b431d6dbc01.svg";
export { ForwardRef as ReactComponent };